import React__default, { createContext, useCallback, useMemo, useContext, useState, useRef, useEffect, createElement } from 'react';
import i18next from 'i18next';
import format from 'date-fns/format';
import { de } from 'date-fns/locale';
import styled, { ThemeProvider } from 'styled-components';
import { down, up } from 'styled-breakpoints';
import axios from 'axios';
var styles = {
  "dealersearch": "_qE6xO"
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }

    return n;
  }, _extends.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};

  for (var n in r) {
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n)) continue;
      t[n] = r[n];
    }
  }

  return t;
}

function _taggedTemplateLiteralLoose(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
} // A type of promise-like that resolves synchronously and supports only one observer


var _iteratorSymbol =
/*#__PURE__*/
typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";

var _asyncIteratorSymbol =
/*#__PURE__*/
typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously call a function and send errors to recovery continuation


function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var LocaleContext = createContext({
  country: 'at',
  lang: 'de',
  locale: 'de-AT',
  t: function t(key, options) {
    return key;
  },
  formatDate: function formatDate(dateString) {
    return dateString;
  },
  formatDateWithLocale: function formatDateWithLocale(date, formatString) {
    return formatString;
  }
});
var resources = {
  en: require('./lang/en'),
  de: require('./lang/de'),
  it: require('./lang/it'),
  fr: require('./lang/fr'),
  es: require('./lang/es')
};
var dateLocales = {
  en: undefined,
  de: de
};
var i18nConfig = {
  fallbackLng: ['de', 'en'],
  nsSeparator: '::',
  resources: resources
};
var instances = {};

var getI18n = function getI18n(lang) {
  if (!instances[lang]) {
    instances[lang] = i18next.createInstance();
    instances[lang].init(_extends({}, i18nConfig, {
      lng: lang,
      initImmediate: true
    }));
  }

  return instances[lang];
};

function LocaleContextProvider(_ref) {
  var children = _ref.children,
      lang = _ref.lang,
      country = _ref.country;
  var i18n = getI18n(lang);

  var formatDateWithLocale = function formatDateWithLocale(date, formatString) {
    var dateLocale = dateLocales[lang];
    console.log('locale', dateLocale);
    return format(date, formatString, {
      locale: dateLocale
    });
  };

  var formatDate = useCallback(function (dateString) {
    return format(new Date(dateString), 'dd.MM.yyyy');
  }, [country]);
  var countryT = useCallback(function (key, options) {
    if (!i18n) return '-';

    if (country && i18n.exists && i18n.exists(key + "_" + country.toLowerCase())) {
      return i18n.t(key + "_" + country.toLowerCase(), _extends({
        returnObjects: true
      }, options));
    }

    return i18n.t(key, _extends({
      returnObjects: true
    }, options));
  }, [country, i18n]);
  var locale = useMemo(function () {
    return "" + lang + (country ? '-' + country.toUpperCase() : '');
  }, [country, lang]);
  var value = useMemo(function () {
    return {
      t: countryT,
      formatDate: formatDate,
      lang: lang,
      country: country,
      locale: locale,
      formatDateWithLocale: formatDateWithLocale
    };
  }, [country, lang, i18n]);
  return (
    /*#__PURE__*/
    React__default.createElement(LocaleContext.Provider, {
      value: value
    }, children)
  );
}

function useLocale() {
  var context = useContext(LocaleContext);
  if (!context) throw new Error('locale context must be used inside a locale context provider.');
  return context;
}

var NotificationContext = createContext({
  notifications: [],
  addNotification: null,
  removeNotification: null
});

function NoticiationContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      notifications = _useState[0],
      setNotifications = _useState[1];

  var removeNotification = useCallback(function (notification) {
    setNotifications(notifications.filter(function (n) {
      return n.id !== notification.id;
    }));
  }, [notifications]);
  var removeRef = useRef(removeNotification);
  removeRef.current = removeNotification;
  var addNotification = useCallback(function (_ref2) {
    var title = _ref2.title,
        message = _ref2.message,
        type = _ref2.type,
        ttl = _ref2.ttl;
    var notification = {
      id: Math.random().toString(36).substr(2, 8),
      title: title,
      message: message,
      type: type || 'success',
      ttl: ttl || 5000
    };
    setNotifications([notification].concat(notifications));
    setTimeout(function () {
      removeRef.current(notification);
    }, notification.ttl);
  }, [notifications]);
  return (
    /*#__PURE__*/
    React__default.createElement(NotificationContext.Provider, {
      value: {
        notifications: notifications,
        addNotification: addNotification,
        removeNotification: removeNotification
      }
    }, children)
  );
}

var useNotifications = function useNotifications() {
  var context = useContext(NotificationContext);
  if (!context) throw new Error('locale context must be used inside a notification context provider.');
  return context;
};

var getFormErrorCode = function getFormErrorCode(e) {
  if (e && e.response && e.response.data && e.response.data.errorCode) {
    var data = e.response.data;
    return data.errorCode.toLowerCase();
  }

  return 'saved_error';
};

var ApiClient =
/*#__PURE__*/
function () {
  function ApiClient(apiUrl) {
    this.apiUrl = apiUrl;
  }

  var _proto = ApiClient.prototype;

  _proto.searchDealer = function searchDealer(_ref) {
    var lat = _ref.lat,
        lng = _ref.lng,
        distance = _ref.distance,
        country = _ref.country,
        brand = _ref.brand,
        qualification = _ref.qualification,
        isXBow = _ref.isXBow;

    try {
      var _this = this;

      return Promise.resolve(_this.get("dealer/dealersearch", {
        latitude: lat,
        longitude: lng,
        distance: distance,
        CountryISO3166_1_alpha2: country,
        brand: brand,
        qualification: qualification,
        isXBow: isXBow
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getDealerDetails = function getDealerDetails(_ref2) {
    var locationId = _ref2.locationId,
        dealerNo = _ref2.dealerNo;

    try {
      var _this2 = this;

      return Promise.resolve(_this2.get("dealer/getdealerbyids", {
        locationId: locationId,
        dealerNo: dealerNo
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getDealerQualifications = function getDealerQualifications(_ref3) {
    var country = _ref3.country,
        _ref3$brand = _ref3.brand,
        brand = _ref3$brand === void 0 ? '1' : _ref3$brand;

    try {
      var _this3 = this;

      return Promise.resolve(_this3.get("dealer/qualifications", {
        CountryISO3166_1_alpha2: country,
        brand: brand
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.get = function get(endpoint, data, options) {
    try {
      var _this4 = this;

      return Promise.resolve(_this4.request(endpoint, 'get', data));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.post = function post(endpoint, data, options) {
    try {
      var _this5 = this;

      return Promise.resolve(_this5.request(endpoint, 'post', data, options));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.put = function put(endpoint, data, options) {
    try {
      var _this6 = this;

      return Promise.resolve(_this6.request(endpoint, 'put', data));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto["delete"] = function _delete(endpoint, data) {
    try {
      var _this7 = this;

      return Promise.resolve(_this7.request(endpoint, 'delete', data));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.updatePreferredDealer = function updatePreferredDealer(data) {
    try {
      var _this8 = this;

      return Promise.resolve(_this8.request('UserProfile/preferreddealer', 'put', data));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getConfigurations = function getConfigurations() {
    try {
      var _this9 = this;

      return Promise.resolve(_this9.get("BikeConfigurator"));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getConfiguration = function getConfiguration(_ref4) {
    var configurationId = _ref4.configurationId;

    try {
      var _this10 = this;

      return Promise.resolve(_this10.get("BikeConfigurator/" + configurationId));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getAccessToken = function getAccessToken(cdcToken) {
    try {
      var _this11 = this;

      var headers = _this11.getAuthHeader(cdcToken);

      return Promise.resolve(_this11.post("Token/createAccessToken", {}, {
        headers: headers
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.initUser = function initUser() {
    try {
      var _this12 = this;

      return Promise.resolve(_this12.post('User', {}));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.userExists = function userExists() {
    try {
      var _this13 = this;

      return Promise.resolve(_this13.get('User/exists'));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getUserProfile = function getUserProfile() {
    var _this14 = this;

    return Promise.resolve(_catch(function () {
      return Promise.resolve(_this14.get('UserProfile'));
    }, function () {}));
  };

  _proto.checkUser = function checkUser() {
    try {
      var _this15 = this;

      return Promise.resolve(_this15.get('user/check'));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.logout = function logout() {
    try {
      var _this16 = this;

      return Promise.resolve(_this16.post('User/logout', {}));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.disableAccount = function disableAccount() {
    try {
      var _this17 = this;

      return Promise.resolve(_this17.post('UserProfile/disableAccount', {}));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.disableReleaseNote = function disableReleaseNote() {
    try {
      var _this18 = this;

      return Promise.resolve(_this18.post('UserProfile/disableReleaseNotes', {}));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.updateUserProfile = function updateUserProfile(data) {
    try {
      var _this19 = this;

      return Promise.resolve(_this19.request('UserProfile', 'put', data));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getFeatureFlags = function getFeatureFlags() {
    try {
      var _this20 = this;

      return Promise.resolve(_this20.get('FeatureFlags'));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getPersonalProfile = function getPersonalProfile() {
    try {
      var _this21 = this;

      return Promise.resolve(_this21.get('UserProfile/personalprofile'));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.updatePersonalProfile = function updatePersonalProfile(data) {
    try {
      var _this22 = this;

      return Promise.resolve(_this22.request("UserProfile/savepersonalprofile", 'post', data));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.updateTheme = function updateTheme(theme) {
    try {
      var _this23 = this;

      return Promise.resolve(_this23.request("UserProfile/themeSwitcher?theme=" + theme, 'put', {}));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.updateLanguage = function updateLanguage(languageCode) {
    try {
      var _this24 = this;

      return Promise.resolve(_this24.request("UserProfile/language?languageCode=" + languageCode, 'put', {}));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getAuthHeader = function getAuthHeader(token) {
    var _ref5;

    var key = process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY || 'Authorization';
    return _ref5 = {}, _ref5[key] = 'Bearer ' + token, _ref5;
  };

  _proto.setLocale = function setLocale(locale, country, language) {
    this.locale = locale;
    this.country = country;
    this.language = language;
  };

  _proto.request = function request(endpoint, method, data, options) {
    if (options === void 0) {
      options = {};
    }

    try {
      var _this25 = this;

      return Promise.resolve(_catch(function () {
        var token = null;
        var url = "" + _this25.apiUrl + endpoint;

        var headers = _extends({}, options.headers || _this25.getAuthHeader(token), {
          'Accept-Language': _this25.locale || '*',
          'Access-Control-Allow-Origin': '*'
        });

        return Promise.resolve(axios({
          url: url,
          method: method,
          headers: headers,
          data: data,
          params: method === 'get' ? data : undefined
        })).then(function (res) {
          return res.data;
        });
      }, function (e) {
        _this25.handleApiError(e);

        return null;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.handleApiError = function handleApiError(e) {
    if (e.response) {
      var _e$response = e.response,
          status = _e$response.status,
          data = _e$response.data;

      if (status === 401 || status !== 412 && data.errorType === 'unauthorized') {
        return null;
      }
    }

    throw e;
  };

  return ApiClient;
}();

var useApiClient = function useApiClient(NEXT_PUBLIC_API_CLIENT_URL) {
  var _useLocale = useLocale(),
      locale = _useLocale.locale,
      country = _useLocale.country,
      lang = _useLocale.lang;

  var apiClient = useMemo(function () {
    return new ApiClient(NEXT_PUBLIC_API_CLIENT_URL);
  }, []);
  useEffect(function () {
    apiClient.setLocale(locale, country, lang);
  }, [locale]);
  return {
    apiClient: apiClient
  };
};

var _dealers;

var useDealerSearch = function useDealerSearch(apiUrl, startBrand, isXBow, startQualification) {
  var _useApiClient = useApiClient(apiUrl),
      apiClient = _useApiClient.apiClient;

  var _useState = useState(_dealers),
      dealers = _useState[0],
      setDealers = _useState[1];

  var _useState2 = useState(null),
      location = _useState2[0],
      setLocation = _useState2[1];

  var _useState3 = useState(isXBow ? 200 : 50),
      distance = _useState3[0],
      setDistance = _useState3[1];

  var _useState4 = useState(startQualification),
      qualification = _useState4[0],
      setQualification = _useState4[1];

  var _useState5 = useState(null),
      qualifications = _useState5[0],
      setQualifications = _useState5[1];

  var _useState6 = useState(startBrand),
      brand = _useState6[0],
      setBrand = _useState6[1];

  var _useLocale = useLocale(),
      country = _useLocale.country;

  var onLoadQualifications = useCallback(function (address) {
    try {
      return Promise.resolve(apiClient.getDealerQualifications({
        country: address ? address.countryCode : country
      })).then(function (qualifications) {
        setQualifications(qualifications);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [setQualifications]);
  var onSearch = useCallback(function () {
    try {
      if (!location) return Promise.resolve();
      return Promise.resolve(apiClient.searchDealer({
        lat: location.lat,
        lng: location.lng,
        distance: distance,
        qualification: qualification,
        country: location ? location.countryCode : country,
        brand: brand ? brand : 'all',
        isXBow: isXBow
      })).then(function (dealers) {
        setDealers(dealers);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [location, distance, qualification, brand]);
  var onSetLocation = useCallback(function (address) {
    try {
      setLocation(address);
      onLoadQualifications(address);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }, [setLocation]);
  var onSetDistance = useCallback(function (value) {
    setDistance(value);
  }, [setDistance]);
  var onSetQualification = useCallback(function (qualificationId) {
    setQualification(qualificationId);
  }, [setQualification]);
  var onSetBrand = useCallback(function (brandName) {
    setBrand(brandName);
  }, [setBrand, brand]);
  useEffect(function () {
    onSearch();
  }, [location, distance, qualification, brand]);
  useEffect(function () {
    onLoadQualifications();
  }, []);
  return {
    location: location,
    distance: distance,
    dealers: dealers,
    qualification: qualification,
    onSetDistance: onSetDistance,
    onSetLocation: onSetLocation,
    onSearch: onSearch,
    qualifications: qualifications,
    onSetQualification: onSetQualification,
    onSetBrand: onSetBrand,
    brand: brand
  };
};

var loaded = false;
var loading = false;

var loadGoogleMapsSdk = function loadGoogleMapsSdk(googleMapsKey) {
  if (googleMapsKey === void 0) {
    googleMapsKey = 'AIzaSyATNvgdpNBR60t0AJnT-zH4jN4aLAn_58c';
  }

  try {
    return Promise.resolve(new Promise(function (resolve, reject) {
      var onLoaded = function onLoaded() {
        loading = false;
        loaded = true;
        resolve();
      };

      var _onCheckLoaded = function onCheckLoaded() {
        if (!loaded) {
          return setTimeout(_onCheckLoaded, 250);
        }

        onLoaded();
      };

      if (loading) {
        _onCheckLoaded();

        return;
      }

      loading = true;

      if (loaded) {
        return onLoaded();
      }

      var url = "https://maps.googleapis.com/maps/api/js?key=" + googleMapsKey + "&libraries=places";
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'google-maps-sdk';

      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            onLoaded();
          }
        };
      } else {
        script.onload = function () {
          return onLoaded();
        };
      }

      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var mapStyle = [{
  featureType: "water",
  elementType: "geometry",
  stylers: [{
    color: "#e9e9e9"
  }, {
    lightness: 17
  }]
}, {
  featureType: "landscape",
  elementType: "geometry",
  stylers: [{
    color: "#f5f5f5"
  }, {
    lightness: 20
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry.fill",
  stylers: [{
    color: "#ffffff"
  }, {
    lightness: 17
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry.stroke",
  stylers: [{
    color: "#ffffff"
  }, {
    lightness: 29
  }, {
    weight: 0.2
  }]
}, {
  featureType: "road.arterial",
  elementType: "geometry",
  stylers: [{
    color: "#ffffff"
  }, {
    lightness: 18
  }]
}, {
  featureType: "road.local",
  elementType: "geometry",
  stylers: [{
    color: "#ffffff"
  }, {
    lightness: 16
  }]
}, {
  featureType: "poi",
  elementType: "geometry",
  stylers: [{
    color: "#f5f5f5"
  }, {
    lightness: 21
  }]
}, {
  featureType: "poi.park",
  elementType: "geometry",
  stylers: [{
    color: "#dedede"
  }, {
    lightness: 21
  }]
}, {
  elementType: "labels.text.stroke",
  stylers: [{
    visibility: "on"
  }, {
    color: "#ffffff"
  }, {
    lightness: 16
  }]
}, {
  elementType: "labels.text.fill",
  stylers: [{
    saturation: 36
  }, {
    color: "#333333"
  }, {
    lightness: 40
  }]
}, {
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "transit",
  elementType: "geometry",
  stylers: [{
    color: "#f2f2f2"
  }, {
    lightness: 19
  }]
}, {
  featureType: "administrative",
  elementType: "geometry.fill",
  stylers: [{
    color: "#fefefe"
  }, {
    lightness: 20
  }]
}, {
  featureType: "administrative",
  elementType: "geometry.stroke",
  stylers: [{
    color: "#fefefe"
  }, {
    lightness: 17
  }, {
    weight: 1.2
  }]
}];

var _templateObject;

var useGoogleMap = function useGoogleMap(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$center = _ref.center,
      center = _ref$center === void 0 ? {
    lat: 48,
    lng: 16
  } : _ref$center,
      _ref$zoom = _ref.zoom,
      zoom = _ref$zoom === void 0 ? 8 : _ref$zoom;

  var mapRef = useRef(null);

  var _useState = useState(null),
      map = _useState[0],
      setMap = _useState[1];

  var _useState2 = useState(null),
      markers = _useState2[0],
      setMarkers = _useState2[1];

  var initMap = useCallback(function () {
    var instance = new google.maps.Map(mapRef.current, {
      center: center,
      zoom: zoom,
      mapTypeControl: false,
      styles: mapStyle,
      streetViewControl: false
    });
    setMap(instance);
  }, [mapRef]);
  var onSetMarkers = useCallback(function (items) {
    if (!map) return;

    if (markers) {
      markers.forEach(function (marker) {
        marker.setMap(null);
      });
    }

    var bounds = new google.maps.LatLngBounds();
    var mapMarkers = items.map(function (item) {
      if (!item.position || !item.position.lat || !item.position.lng) {
        console.warn('item has no position', item);
        return;
      }

      bounds.extend(item.position);
      var marker = new google.maps.Marker({
        position: item.position,
        map: map,
        title: item.title,
        icon: '/icons/map-pin.png'
      });

      if (item.onClick) {
        marker.addListener('click', item.onClick);
      }

      return marker;
    });
    setMarkers(mapMarkers);
    if (mapMarkers.length) map.fitBounds(bounds);
  }, [map, setMarkers, markers]);
  var onInit = useCallback(function () {
    try {
      return Promise.resolve(loadGoogleMapsSdk(window['GOOGLE_MAPS_KEY'])).then(function () {
        initMap();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);
  useEffect(function () {
    onInit();
  }, []);
  return {
    mapRef: mapRef,
    onSetMarkers: onSetMarkers,
    map: map
  };
};

var StyledGoogleMapsWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\toverflow: hidden;\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: ", ";\n\tbackground-color: rgba(245, 245, 245, 1);\n\n\t&::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\twidth: 45%;\n\t\theight: 100%;\n\t\tdisplay: inline-block;\n\t\tbackground: rgba(245, 245, 245, 1);\n\t\tbackground: linear-gradient(\n\t\t\tto left,\n\t\t\trgba(245, 245, 245, 0),\n\t\t\trgba(245, 245, 245, 1) 50%,\n\t\t\trgba(245, 245, 245, 1) 75%\n\t\t);\n\n\t\t", " {\n\t\t\twidth: 100%;\n\t\t\theight: 12rem;\n\t\t\tbackground: rgba(245, 245, 245, 1);\n\t\t}\n\t}\n\n\t.map {\n\t\tmin-height: 200px;\n\t\twidth: 70%;\n\t\theight: calc(100vh - 3rem);\n\t\tdisplay: block;\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\n\t\t", " {\n\t\t\twidth: 100%;\n\t\t\theight: calc(100% - 6rem);\n\t\t\tmargin-top: 12rem;\n\t\t}\n\t}\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.shape.borderRadius;
}, down('md'), down('md'));

var GoogleMaps = function GoogleMaps(_ref3) {
  var markers = _ref3.markers,
      isXBow = _ref3.isXBow;

  var _useGoogleMap = useGoogleMap({
    zoom: isXBow ? 6 : 8
  }),
      mapRef = _useGoogleMap.mapRef,
      onSetMarkers = _useGoogleMap.onSetMarkers;

  useEffect(function () {
    onSetMarkers(markers);
  }, [markers]);
  return (
    /*#__PURE__*/
    React__default.createElement(StyledGoogleMapsWrapper, null,
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "map",
      ref: mapRef
    }))
  );
};

function SearchIcon() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 17.5 17.66"
    },
    /*#__PURE__*/
    React__default.createElement("g", {
      id: "search-icon",
      "data-name": "Search Icon"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M17.28,16.38,11.93,11A6.72,6.72,0,0,0,6.72,0,6.65,6.65,0,0,0,2,2a6.71,6.71,0,0,0,0,9.5,6.71,6.71,0,0,0,8.89.54l5.35,5.42a.76.76,0,0,0,.54.23.76.76,0,0,0,.53-1.28ZM3,10.41A5.21,5.21,0,0,1,3,3a5.21,5.21,0,0,1,7.38,0,5.23,5.23,0,0,1,0,7.38l0,0h0a5.22,5.22,0,0,1-7.34,0Z"
    })))
  );
}

function LocationIcon() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19.5 20.5"
    },
    /*#__PURE__*/
    React__default.createElement("g", {
      id: "location-icon",
      "data-name": "Location Icon"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M14,12.41A10.24,10.24,0,0,0,16.5,6.58,6.67,6.67,0,0,0,9.75,0,6.67,6.67,0,0,0,3,6.58a10.24,10.24,0,0,0,2.46,5.83C2.06,13.09,0,14.51,0,16.25,0,19,5,20.5,9.75,20.5S19.5,19,19.5,16.25C19.5,14.51,17.44,13.09,14,12.41ZM9.75,1.5A5.17,5.17,0,0,1,15,6.58c0,3.28-3.88,7-5.25,8.19C8.38,13.56,4.5,9.86,4.5,6.58A5.17,5.17,0,0,1,9.75,1.5Zm0,17.5c-5,0-8.25-1.63-8.25-2.75,0-.87,1.9-2,5.08-2.51a25.93,25.93,0,0,0,2.7,2.6.77.77,0,0,0,.94,0,25.93,25.93,0,0,0,2.7-2.6c3.18.49,5.08,1.64,5.08,2.51C18,17.37,14.79,19,9.75,19Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M11.69,8.69a2.73,2.73,0,0,0,0-3.88,2.8,2.8,0,0,0-3.88,0,2.74,2.74,0,1,0,3.88,3.88ZM8.5,6.75a1.25,1.25,0,1,1,2.13.88,1.26,1.26,0,0,1-1.76,0A1.22,1.22,0,0,1,8.5,6.75Z"
    })))
  );
}

var _templateObject$1;

var autoComplete;
var autoCompleteListener;
var geoCoder;

var handleScriptLoad = function handleScriptLoad(onSelect, autoCompleteRef) {
  geoCoder = new google.maps.Geocoder();
  autoComplete = new window.google.maps.places.Autocomplete(autoCompleteRef.current, {
    types: ['geocode']
  });
  autoCompleteListener = autoComplete.addListener('place_changed', function () {
    var addressObject = autoComplete.getPlace();
    onSelect(addressObject);
  });
  return autoComplete;
};

var geoCodeAddress = function geoCodeAddress(address) {
  try {
    return Promise.resolve(new Promise(function (resolve, reject) {
      if (!address || address.length < 4) {
        return resolve(null);
      }

      geoCoder.geocode({
        address: address
      }, function (results, status) {
        try {
          var result = results[0];

          if (status === google.maps.GeocoderStatus.OK) {
            resolve(result);
          } else {
            resolve(null);
          }

          return Promise.resolve();
        } catch (e) {
          return Promise.reject(e);
        }
      });
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var useAddressAutoComplete = function useAddressAutoComplete(_ref) {
  var value = _ref.value,
      onSelect = _ref.onSelect;

  var _useState = useState(value || ''),
      query = _useState[0],
      setQuery = _useState[1];

  var _useState2 = useState(false),
      autoCompleteLoaded = _useState2[0],
      setAutoCompleteLoaded = _useState2[1];

  var _useState3 = useState(false),
      autoCompleteInitalized = _useState3[0],
      setAutoCompleteInitalized = _useState3[1];

  var autoCompleteRef = useRef(null);
  var setAddress = useCallback(function (addressObject) {
    var countryName = addressObject.address_components.filter(function (component) {
      if (component.types[0] == 'country') {
        return component;
      }
    });
    var address = {
      lat: addressObject.geometry.location.lat(),
      lng: addressObject.geometry.location.lng(),
      formatted: addressObject.formatted_address,
      countryCode: countryName[0].short_name
    };
    onSelect(address);
    setQuery(address.formatted);
  }, [onSelect]);
  var onSelectFromDropdown = useCallback(function (addressObject) {
    if (addressObject.geometry) {
      setAddress(addressObject);
    }
  }, [setAddress]);
  var onChange = useCallback(function (event) {
    setQuery(event.target.value);
  }, [setQuery]);
  var onKeyDown = useCallback(function (event) {
    try {
      if (event.target.value.length < 3) {
        event.stopPropagation();
      }

      var _temp = function () {
        if (event.keyCode === 13) {
          var _value = event.target.value;
          return Promise.resolve(geoCodeAddress(_value)).then(function (addressObject) {
            setAddress(addressObject);
          });
        }
      }();

      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }, [query]);
  useEffect(function () {
    if (!autoCompleteLoaded || query.length < 2) return;

    if (!autoCompleteInitalized) {
      var _autoComplete = handleScriptLoad(onSelectFromDropdown, autoCompleteRef);

      setAutoCompleteInitalized(true);
    }
  }, [autoCompleteLoaded, query]);
  var onInit = useCallback(function () {
    try {
      return Promise.resolve(loadGoogleMapsSdk(window['GOOGLE_MAPS_KEY'])).then(function () {
        setAutoCompleteLoaded(true);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [autoCompleteLoaded]);
  useEffect(function () {
    onInit();
  }, []);
  return {
    autoCompleteRef: autoCompleteRef,
    query: query,
    onChange: onChange,
    onKeyDown: onKeyDown
  };
};

var StyledInputWrapper = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\twidth: 70%;\n\n\t", " {\n\t\twidth: 100%;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\tlabel {\n\t\tdisplay: block;\n\t\tcolor: ", ";\n\t\tfont-size: ", ";\n\t\tfont-family: ", ";\n\t\tfont-weight: ", ";\n\t\ttext-transform: uppercase;\n\t\twidth: 100%;\n\t\tpadding-bottom: 0.5rem;\n\t}\n\n\t.input-wrapper {\n\t\tborder-radius: ", ";\n\t\tbackground: ", ";\n\t\tpadding: 0.8rem 1.2rem;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\tinput {\n\t\t\twidth: 100%;\n\t\t\tcolor: ", ";\n\t\t\tfont-size: ", ";\n\t\t\tfont-family: ", ";\n\t\t\tline-height: 2rem;\n\t\t\tbackground: transparent;\n\t\t\tborder: none;\n\n\t\t\t&:focus {\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tmargin: 0 1.5rem 0 0.5rem;\n\n\t\t\t&.location-icon {\n\t\t\t\tmargin-right: 0.5rem;\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\twidth: auto;\n\t\t\t\theight: 20px;\n\t\t\t\tfill: ", ";\n\t\t\t}\n\t\t}\n\t}\n\n\t.pac-container {\n\t\tbackground: transparent !important;\n\t}\n\t.pac-item {\n\t\tbackground: transparent !important;\n\t}\n"])), down('md'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.fontSize.xs;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.h5.fontFamily;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.h5.fontWeight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.shape.borderRadius;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.background.sidebar;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.text;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.body1.fontSize;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.body1.fontFamily;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary;
});

var GoogleAddressAutoComplete = function GoogleAddressAutoComplete(_ref12) {
  var placeholder = _ref12.placeholder,
      label = _ref12.label,
      value = _ref12.value,
      onSelect = _ref12.onSelect;

  var _useAddressAutoComple = useAddressAutoComplete({
    value: value,
    onSelect: onSelect
  }),
      autoCompleteRef = _useAddressAutoComple.autoCompleteRef,
      onChange = _useAddressAutoComple.onChange,
      query = _useAddressAutoComple.query,
      onKeyDown = _useAddressAutoComple.onKeyDown;

  return (
    /*#__PURE__*/
    React__default.createElement(StyledInputWrapper, {
      className: "address-auto-complete"
    }, label ?
    /*#__PURE__*/
    React__default.createElement("label", null, label) : null,
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "input-wrapper"
    },
    /*#__PURE__*/
    React__default.createElement("span", {
      className: "search-icon"
    },
    /*#__PURE__*/
    React__default.createElement(SearchIcon, null)),
    /*#__PURE__*/
    React__default.createElement("input", {
      ref: autoCompleteRef,
      onChange: onChange,
      placeholder: placeholder,
      value: query,
      onKeyDown: onKeyDown
    }),
    /*#__PURE__*/
    React__default.createElement("span", {
      className: "location-icon"
    },
    /*#__PURE__*/
    React__default.createElement(LocationIcon, null))))
  );
};

var _templateObject$2, _templateObject2;

var DropDownList = styled.ul(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n\tpadding: 0;\n\tmargin: 0;\n\ttop: 100%;\n\tbackground: ", ";\n\tposition: absolute;\n\twidth: 90%;\n\tz-index: 5;\n\tbox-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);\n\toverflow-y: auto;\n\tmax-height: 200px;\n\n\t::-webkit-scrollbar {\n\t\twidth: 3px;\n\t}\n\n\t::-webkit-scrollbar-track {\n\t\tbackground: transparent;\n\t}\n\n\t::-webkit-scrollbar-thumb {\n\t\tbackground: ", ";\n\t}\n\n\t::-webkit-scrollbar-thumb:hover {\n\t\tbackground: ", ";\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.background.sidebar;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
var ListItem = styled.li(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tlist-style: none;\n\tpadding: 1rem;\n\tcolor: ", ";\n\tbackground: ", ";\n\tfont-family: ", ";\n\n\t&:hover {\n\t\tbackground: ", " !important;\n\t}\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.text;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.background.sidebar;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.body1.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.background.content;
});

function ArrowSimpleIcon() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 6.5 11.5"
    },
    /*#__PURE__*/
    React__default.createElement("g", {
      id: "arrow-icon",
      "data-name": "Arrow Icon"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M6.28,5.22l-5-5A.75.75,0,0,0,.22,1.28L4.69,5.75.22,10.22a.75.75,0,0,0,0,1.06.75.75,0,0,0,1.06,0l5-5A.75.75,0,0,0,6.28,5.22Z"
    })))
  );
}

var _templateObject$3;

var StyledDropdown = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\n\tlabel {\n\t\tdisplay: block;\n\t\tcolor: ", ";\n\t\tfont-size: ", ";\n\t\tline-height: ", ";\n\t\tfont-family: ", ";\n\t\tfont-weight: ", ";\n\t\ttext-transform: uppercase;\n\t}\n\n\t.select-dropdown {\n\t\twidth: 100%;\n\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t}\n\t}\n\n\t.select-input {\n\t\tborder-radius: ", ";\n\t\tbackground: ", ";\n\t\tpadding: 0.8rem 1.2rem;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\n\t\t&.open {\n\t\t\tborder-radius: ", "\n\t\t\t\t", " 0 0;\n\t\t\tspan {\n\t\t\t\tsvg {\n\t\t\t\t\ttransform: rotate(90deg);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\tinput {\n\t\t\twidth: 100%;\n\t\t\tcolor: ", ";\n\t\t\tfont-size: ", ";\n\t\t\tfont-family: ", ";\n\t\t\tline-height: 2rem;\n\t\t\tbackground: transparent;\n\t\t\tborder: none;\n\t\t\t/* border-bottom: 1px solid ", "; */\n\t\t\tcursor: pointer;\n\n\t\t\t&:focus {\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t}\n\n\t\tspan {\n\t\t\tsvg {\n\t\t\t\twidth: 7px;\n\t\t\t\theight: auto;\n\t\t\t\tfill: ", ";\n\t\t\t\ttransition: transform 0.2s;\n\t\t\t\ttransition-timing-function: ", ";\n\t\t\t}\n\t\t}\n\t}\n\n\tul {\n\t\tborder: none !important;\n\t\tborder-top: ", " !important;\n\t\tborder-radius: ", ";\n\t\twidth: 90% !important;\n\t\ttop: 100%;\n\t\tmax-height: 200px;\n\t\toverflow-y: auto;\n\t\tborder-radius: 0 0 ", "\n\t\t\t", ";\n\n\t\t", " {\n\t\t\tmax-height: 260px;\n\t\t}\n\n\t\tli {\n\t\t\tfont-size: 16px;\n\t\t\tfont-family: ", ";\n\t\t\tline-height: 2rem;\n\t\t}\n\n\t\t::-webkit-scrollbar {\n\t\t\twidth: 5px;\n\t\t}\n\n\t\t::-webkit-scrollbar-track {\n\t\t\tbackground: transparent;\n\t\t}\n\n\t\t::-webkit-scrollbar-thumb {\n\t\t\tbackground: ", ";\n\t\t}\n\n\t\t::-webkit-scrollbar-thumb:hover {\n\t\t\tbackground: ", ";\n\t\t}\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.body2.fontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.body1.lineHeight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.h5.fontFamily;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.body2.fontFamily;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.shape.borderRadius;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.background.sidebar;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.shape.borderRadius;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.shape.borderRadius;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.text;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.body1.fontSize;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.typography.body1.fontFamily;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.greyMedium;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.primary;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.transitions.easeInQuad;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.grey;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.shape.borderRadius;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.shape.borderRadius;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.shape.borderRadius;
}, up('md'), function (_ref20) {
  var theme = _ref20.theme;
  return theme.typography.body1.fontFamily;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.primary;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.primary;
});

var useClickOutside = function useClickOutside(ref, callback) {
  var handleClick = function handleClick(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  React__default.useEffect(function () {
    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  });
};

var DropdownSelect = function DropdownSelect(_ref23) {
  var label = _ref23.label,
      placeholder = _ref23.placeholder,
      value = _ref23.value,
      options = _ref23.options,
      onChange = _ref23.onChange,
      active = _ref23.active,
      id = _ref23.id,
      trackingClass = _ref23.trackingClass;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var clickRef = React__default.useRef();
  var onOpen = useCallback(function () {
    setIsOpen(false);
  }, [isOpen]);
  var selectedItem = useMemo(function () {
    return options.find(function (option) {
      return option.value + '' === value + '';
    });
  }, [value, options]);
  var onClickOutside = useCallback(function () {
    setIsOpen(false);
  }, [isOpen, setIsOpen]);
  var onSelect = useCallback(function (item) {
    onChange(item);
    setIsOpen(false);
  }, [onChange]);
  useClickOutside(clickRef, onClickOutside);
  var inputValue = selectedItem ? selectedItem.label : placeholder;
  return (
    /*#__PURE__*/
    React__default.createElement(StyledDropdown, {
      ref: clickRef,
      className: active ? 'active' : null
    }, label ?
    /*#__PURE__*/
    React__default.createElement("label", null, label) : null,
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "select-dropdown"
    },
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "select-input " + (trackingClass ? trackingClass : '') + " " + (id ? 'select-input-' + id : '') + " " + (isOpen && options.length !== 0 ? 'open' : ''),
      onClick: function onClick() {
        return setIsOpen(!isOpen);
      }
    },
    /*#__PURE__*/
    React__default.createElement("input", {
      value: inputValue,
      readOnly: true
    }),
    /*#__PURE__*/
    React__default.createElement("span", null,
    /*#__PURE__*/
    React__default.createElement(ArrowSimpleIcon, null))), isOpen && options.length !== 0 &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "select-select",
      tabIndex: 0,
      onBlur: onOpen
    },
    /*#__PURE__*/
    React__default.createElement(DropDownList, null, options.map(function (_ref24, index) {
      var label = _ref24.label,
          value = _ref24.value;
      return (
        /*#__PURE__*/
        React__default.createElement(ListItem, {
          onClick: function onClick() {
            return onSelect({
              label: label,
              value: value
            });
          },
          key: value,
          value: value,
          id: id ? 'select-item-' + id + '-' + index : null
        }, label)
      );
    })))))
  );
};

var _templateObject$4;

var StyledButton = styled.button(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n\tcursor: ", ";\n\tfont-size: ", ";\n\tfont-family: ", ";\n\tfont-weight: ", ";\n\tfont-style: ", ";\n\tline-height: ", ";\n\ttext-transform: ", ";\n\toutline: none;\n\tpadding: 1.3rem 2.3rem;\n\tborder: 1px solid\n\t\t", ";\n\tborder-radius: ", ";\n\tbackground: ", ";\n\tcolor: ", ";\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\tsvg {\n\t\tfill: ", ";\n\t}\n\n\t&.secondary-button {\n\t\tborder: 1px solid\n\t\t\t", ";\n\t\tborder-radius: ", ";\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\n\t\tsvg {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n\n\t&:hover {\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\n\t\tsvg {\n\t\t\tfill: ", ";\n\t\t}\n\t}\n\n\t&.red-button {\n\t\tborder: 1px solid\n\t\t\t", ";\n\t\tborder-radius: ", ";\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t}\n\n\t", " {\n\t\twidth: 100%;\n\t}\n"])), function (_ref) {
  var disabled = _ref.disabled,
      inactive = _ref.inactive;
  return disabled || inactive ? 'default' : 'pointer';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.button.fontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.button.fontFamily;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.button.fontWeight;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.button.fontStyle;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.button.lineHeight;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.button.textTransform;
}, function (_ref8) {
  var theme = _ref8.theme,
      inactive = _ref8.inactive;
  return inactive ? theme.colors.greyMedium : theme.colors.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.shape.borderRadiusButton;
}, function (_ref10) {
  var theme = _ref10.theme,
      inactive = _ref10.inactive;
  return inactive ? theme.colors.greyMedium : theme.colors.primary;
}, function (_ref11) {
  var theme = _ref11.theme,
      inactive = _ref11.inactive;
  return inactive ? theme.colors.white : theme.colors.white;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.white;
}, function (_ref13) {
  var theme = _ref13.theme,
      inactive = _ref13.inactive;
  return inactive ? theme.colors.greyMedium : theme.colors.primary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.shape.borderRadiusButton;
}, function (_ref15) {
  var theme = _ref15.theme,
      inactive = _ref15.inactive;
  return inactive ? theme.colors.greyMedium : 'transparent';
}, function (_ref16) {
  var theme = _ref16.theme,
      inactive = _ref16.inactive;
  return inactive ? theme.colors.white : theme.colors.primary;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.primary;
}, function (_ref18) {
  var theme = _ref18.theme,
      disabled = _ref18.disabled,
      inactive = _ref18.inactive;
  return disabled ? inactive ? theme.colors.greyMedium : theme.colors.primary : theme.colors.primary;
}, function (_ref19) {
  var theme = _ref19.theme,
      disabled = _ref19.disabled,
      inactive = _ref19.inactive;
  return disabled ? inactive ? theme.colors.white : theme.colors.primary : theme.colors.white;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.white;
}, function (_ref21) {
  var theme = _ref21.theme,
      inactive = _ref21.inactive;
  return inactive ? theme.colors.greyMedium : theme.colors.white;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.shape.borderRadiusButton;
}, function (_ref23) {
  var theme = _ref23.theme,
      inactive = _ref23.inactive;
  return inactive ? theme.colors.greyMedium : theme.colors.error;
}, function (_ref24) {
  var theme = _ref24.theme,
      disabled = _ref24.disabled,
      inactive = _ref24.inactive;
  return disabled ? inactive ? theme.colors.white : theme.colors.greyMedium : theme.colors.white;
}, function (_ref25) {
  var theme = _ref25.theme,
      inactive = _ref25.inactive;
  return inactive ? theme.colors.greyMedium : theme.colors.error;
}, function (_ref26) {
  var theme = _ref26.theme,
      disabled = _ref26.disabled,
      inactive = _ref26.inactive;
  return disabled ? inactive ? theme.colors.white : theme.colors.error : theme.colors.white;
}, down('sm'));

var Button = function Button(props) {
  var children = props.children;
  return (
    /*#__PURE__*/
    React__default.createElement(StyledButton, props, children)
  );
};

function KTMLogo() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 166.4 51.67"
    },
    /*#__PURE__*/
    React__default.createElement("g", {
      id: "ktm-logo",
      "data-name": "KTM Logo"
    },
    /*#__PURE__*/
    React__default.createElement("polygon", {
      points: "145.13 11.85 127.89 27.12 131.3 11.85 110.89 11.85 88.63 34.26 97.9 6.85 131.87 6.85 133.42 0 44.24 0 41.68 6.85 74.5 6.85 60.64 41.95 49.81 27.55 68.63 11.84 52.81 11.84 33.53 27.41 39.97 11.84 17 11.84 0 51.66 23.27 51.66 29.11 37.4 39.97 51.66 89.91 51.66 105.46 37.26 102.89 51.66 122.45 51.66 138.71 37.4 136.42 51.67 157.7 51.67 166.4 11.85 145.13 11.85"
    })))
  );
}

function HQVLogo() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 154.18 123.17"
    },
    /*#__PURE__*/
    React__default.createElement("g", {
      id: "hqv-logo",
      "data-name": "HQV Logo"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M80.68,48.68V61.76h8.77V25.56H80.68V36.42c0,2.16.09,2.16-6.14,2.16s-6.32,0-6.32-2.16V25.57H59.58v36.2h8.64V48.69c0-2.08,0-2.08,6.32-2.08S80.68,46.61,80.68,48.68Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M74.52,77.37c6.35,0,17.86.61,24.43-6.81,3.19-3.61,4-6,5.59-11.09,1.4-4.47,1.2-7.14,1.65-12.06a57.36,57.36,0,0,0-.89-14.21c-1.34-7-2.35-10.7-5.47-13.88,4.12-2.14,4.7-8.43,4.12-12.72,0,0-3.15-1.59-5.26-2.38-2.31-.88-6-1.83-6-1.83,0,3.38.4,8.5-2.09,10.19-2.55,1.49-8.77,0-9.78-3.24a24.14,24.14,0,0,1,0-8.56A29.67,29.67,0,0,0,74.42,0,25.54,25.54,0,0,0,68.2.78c.44,4.22.32,7.58,0,8.56-1.09,3.24-7.24,4.73-9.71,3.24-2.74-1.69-2.11-6.81-2.11-10.19a67.68,67.68,0,0,0-6.48,2c-2,.77-5,2.26-5,2.26-.64,4.29,0,10.58,4.13,12.72-3.12,3.18-4.13,6.93-5.47,13.88a65.53,65.53,0,0,0-.76,14.2c.31,4.92.31,7.59,1.46,12.06,1.65,5.14,2.62,7.53,6,11.09,6.79,7.22,17.93,6.82,24.3,6.82ZM61,67.05a8.73,8.73,0,0,1-5.21-3.76C52.69,58,52.69,48,52.69,43.19s0-13.29,3.05-18.53A8.57,8.57,0,0,1,61,20.83c3.68-1,6.15-1,13.59-1,7.24,0,9.73,0,13.47,1a8,8,0,0,1,5,3.83c3.3,5.25,3.3,14.32,3.3,19.12S96.34,58,93,63.29a8.18,8.18,0,0,1-5,3.76c-3.74,1-6.22,1-13.47,1C67.1,68.08,64.63,68.08,61,67.05Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M67.1,92a5.77,5.77,0,0,0-4.86-2.72c-5.06,0-8,3.66-8,9.54a10.39,10.39,0,0,0,2.56,7.32,6.29,6.29,0,0,0,4.82,2,6.49,6.49,0,0,0,5.28-2.68v7.08h4.25V89.78h-4Zm-4.32,12.61A3.48,3.48,0,0,1,60,103.48a6.74,6.74,0,0,1-1.57-4.75A6.91,6.91,0,0,1,60.13,94a3.37,3.37,0,0,1,2.64-1.16c2.46,0,3.78,1.63,4.16,4.57.06.45.09,2.07.09,2.38C66.72,102.91,65.39,104.63,62.78,104.63Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M140,97.14c-3.06.3-6.74,1.16-6.74,5.69a5.07,5.07,0,0,0,1.4,3.62,6.45,6.45,0,0,0,4.67,1.74c2.55,0,4-.63,5.32-2.13l.21,1.66H149v-.67c-.54-.42-.4-2.21-.4-2.21V94.62a4.64,4.64,0,0,0-1.3-3.35,8,8,0,0,0-5.77-2c-2.52,0-6.77.56-7.27,5.42h4.26c-.06-2.26,2.78-2.06,2.78-2.06a4.53,4.53,0,0,1,2.62.78,1.77,1.77,0,0,1,.61,1.52C144.61,96.17,144,96.76,140,97.14Zm4.32,4.48c0,2.22-2.18,3-3.75,3s-3-.63-3.07-2,.66-2.32,2.66-2.68c.53-.1,1.06-.15,1.6-.22a6.22,6.22,0,0,0,2.56-.92Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M105.16,89.77v17.94h4.27V99.14c0-1.94.12-3.42,1-4.56a4.16,4.16,0,0,1,3-1.75,6,6,0,0,1,1.84.32V89.27a6.87,6.87,0,0,0-2.35-.08c-1.39.21-3,1.81-3.75,3.71V89.77Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M32.2,100.29c0,3-1.16,4.49-3.57,4.49a2.86,2.86,0,0,1-2.1-.87,4.55,4.55,0,0,1-.92-3.2V89.77H21.37v11.31c0,2.48.55,4.26,1.7,5.42a5.84,5.84,0,0,0,4.66,1.67,6.37,6.37,0,0,0,4.53-2.48v2h4.21V89.77H32.2Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M47.63,96.9l-.93-.23c-2.3-.46-4.19-.92-4.09-2.29s1.55-1.65,2.69-1.65a2.5,2.5,0,0,1,2.75,1.49h4.42c-.44-3.47-3.58-5-6.9-4.93s-7.16,1.38-7.16,5.23c0,3.63,2.48,4.74,5.44,5.39l1.17.27c2.24.46,3.89.92,3.89,2.4s-1.16,2.09-3,2.15-3.24-.76-3.51-2.38H38.13c.2,4.53,4.66,5.9,7.73,5.82s4.49-.79,5.88-2.21a5.11,5.11,0,0,0,1.45-3.7C53.19,98.76,50.58,97.6,47.63,96.9Z"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      points: "82.61 107.7 88.65 89.77 84.24 89.77 80.46 103.57 76.55 89.77 71.95 89.77 78.05 107.7 82.61 107.7"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M121,97.12a4.56,4.56,0,0,1,1.07-3.28A4,4,0,0,1,125,92.71c1.95,0,2.62,1.21,2.7,3.78v11.22h4.22V95.44a5.69,5.69,0,0,0-5.19-6.15,5,5,0,0,0-1,0c-2.09,0-3.65,1.12-4.92,3.17v-2.7h-4v17.94H121Z"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      points: "14.32 92.93 4.62 92.93 4.62 83.78 0 83.78 0 107.71 4.62 107.71 4.62 97.07 14.32 97.07 14.32 107.71 18.92 107.71 18.92 83.78 14.32 83.78 14.32 92.93"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M94.29,97.13c-3.09.3-6.75,1.16-6.75,5.67a5.07,5.07,0,0,0,1.38,3.62,6.53,6.53,0,0,0,4.68,1.74c2.55,0,4-.63,5.33-2.13l.21,1.67h4.09V107c-.53-.43-.41-2.21-.41-2.21V94.6a4.62,4.62,0,0,0-1.31-3.34,7.23,7.23,0,0,0-5.47-2c-2.51,0-6.78.55-7.27,5.42H93c-.06-2.28,2.78-2.07,2.78-2.07a3.62,3.62,0,0,1,2.33.78A1.81,1.81,0,0,1,98.77,95C98.84,96.16,98.27,96.74,94.29,97.13Zm4.28,4.48c0,2.22-2.18,3-3.75,3s-2.94-.63-3-2,.65-2.32,2.66-2.67c.52-.11,1.06-.15,1.59-.23a6,6,0,0,0,2.55-.93Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M152.67,87.71v-.43a1,1,0,0,0-.17-.51,1,1,0,0,0-.29-.24l.16-.07a.72.72,0,0,0,.33-.68.82.82,0,0,0-.51-.84,2.42,2.42,0,0,0-.85-.1h-1.12V88h.7V86.84h.32a1.29,1.29,0,0,1,.52.07.67.67,0,0,1,.25.61v.41l0,.08h.71l-.08-.18S152.68,87.78,152.67,87.71Zm-.89-1.51a1.08,1.08,0,0,1-.47.07h-.38v-.9h.34a1.59,1.59,0,0,1,.61.09.44.44,0,0,1,.15.38A.34.34,0,0,1,151.78,86.2Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M153.38,84.44a2.76,2.76,0,0,0-3.9,0l0,0a2.88,2.88,0,0,0,0,4,2.72,2.72,0,0,0,3.85.08l.08-.08A2.87,2.87,0,0,0,153.38,84.44Zm-.4,3.61a2.08,2.08,0,0,1-1.57.65,2.2,2.2,0,0,1-1.59-.65,2.31,2.31,0,0,1-.65-1.62A2.25,2.25,0,0,1,153,84.78l0,0a2.18,2.18,0,0,1,.66,1.62A2.22,2.22,0,0,1,153,88.05Z"
    }),
    /*#__PURE__*/
    React__default.createElement("rect", {
      x: "75.39",
      y: "111.3",
      width: "73.6",
      height: "1.26"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      points: "79.13 120.87 79.11 120.87 77.52 116.17 75.39 116.17 75.39 123 76.81 123 76.81 118.21 76.83 118.21 78.5 123 79.64 123 81.33 118.16 81.34 118.16 81.34 123 82.75 123 82.75 116.17 80.64 116.17 79.13 120.87"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M87.22,116h-.34a3.32,3.32,0,0,0-3,3.59c0,.06,0,.13,0,.2a3.58,3.58,0,1,0,3.35-3.8Zm0,5.89c-1.35,0-1.86-1.15-1.86-2.29s.52-2.34,1.86-2.34,1.85,1.14,1.85,2.34S88.57,121.9,87.22,121.9Z"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      points: "91 117.43 93.05 117.43 93.06 123 94.56 123 94.56 117.43 96.61 117.43 96.61 116.17 91 116.17 91 117.43"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M100.36,116H100a3.32,3.32,0,0,0-3,3.59c0,.06,0,.13,0,.2a3.58,3.58,0,1,0,3.34-3.8Zm0,5.89c-1.34,0-1.84-1.15-1.84-2.29s.5-2.34,1.84-2.34,1.86,1.14,1.86,2.34S101.71,121.9,100.36,121.9Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M109.44,119.79v0a1.69,1.69,0,0,0,1.09-1.71v-.14a1.89,1.89,0,0,0-2-1.75h-3.69V123h1.5v-2.66h1.5c.76,0,1,.31,1.14,1a10,10,0,0,0,.24,1.63h1.5a3.75,3.75,0,0,1-.28-1.62C110.39,120.69,110.18,120,109.44,119.79Zm-1.46-.53h-1.64v-1.92H108c.69,0,1,.28,1,.94S108.66,119.26,108,119.26Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M116.36,120.38a1.53,1.53,0,0,1-1.54,1.52c-1.36,0-1.87-1.15-1.87-2.29s.51-2.34,1.87-2.34a1.5,1.5,0,0,1,1.49,1.2h1.45a2.77,2.77,0,0,0-2.94-2.46,3.59,3.59,0,0,0,0,7.16h0a2.87,2.87,0,0,0,3-2.79h-1.46Z"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      points: "121.17 118.87 119.56 116.17 117.88 116.17 120.39 120.34 120.39 123 121.89 123 121.89 120.38 124.42 116.17 122.75 116.17 121.17 118.87"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M129.33,120.38a1.53,1.53,0,0,1-1.54,1.52c-1.35,0-1.86-1.15-1.86-2.29s.5-2.34,1.86-2.34a1.5,1.5,0,0,1,1.49,1.2h1.45a2.77,2.77,0,0,0-2.94-2.46,3.59,3.59,0,0,0,0,7.16h0a2.87,2.87,0,0,0,3-2.79h-1.46Z"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      points: "133.38 116.17 131.88 116.17 131.88 123 136.71 123 136.71 121.74 133.38 121.74 133.38 116.17"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      points: "139.06 120.06 142.37 120.06 142.37 118.89 139.06 118.89 139.06 117.43 142.66 117.43 142.66 116.17 137.56 116.17 137.56 122.99 142.74 122.99 142.74 121.73 139.06 121.73 139.06 120.06"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M147.15,119c-1.71-.43-2-.51-2-1s.56-.78,1-.78c.73,0,1.3.22,1.36,1H149c0-1.58-1.3-2.2-2.73-2.2-1.23,0-2.55.66-2.56,2.07s1,1.69,2,1.94,2,.38,2,1.13-.8.85-1.33.85c-.8,0-1.51-.35-1.51-1.26h-1.46c0,1.68,1.4,2.43,2.91,2.43,1.87,0,2.84-.94,2.84-2.19C149.18,119.43,147.66,119.09,147.15,119Z"
    })))
  );
}

function GasGasLogo() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 166.76 108.97"
    },
    /*#__PURE__*/
    React__default.createElement("g", {
      id: "gasgas-logo",
      "data-name": "GasGas Logo"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M41,88.22,24.41,109h8.05l2.64-3.71H46l.94,3.71h7.83L49,88.22Zm-2.54,12.37,4.72-6.65,1.68,6.65Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M64.85,94.25a2.1,2.1,0,0,1,2-1.45h16.3l0-1.35a3.32,3.32,0,0,0-3.4-3.23H65.07c-1.8,0-5.46,1.16-6.21,3.82l-1.18,4c-1,3,1,4.52,2.94,4.52h13a1.3,1.3,0,0,1,1.3,1.29,1.45,1.45,0,0,1-.06.41l-.14.44a2.36,2.36,0,0,1-2.18,1.65H55.69l-.1,1.93a2.9,2.9,0,0,0,3,2.65H74.85a7.51,7.51,0,0,0,4.82-2.37c1.07-1.25,2.23-5.26,2.24-7.16a3.29,3.29,0,0,0-3.33-3.23H65.85A1.19,1.19,0,0,1,64.66,95a1.09,1.09,0,0,1,.06-.36Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M28.39,96.21H14l-1.49,4.64h8l-.6,1.78a3,3,0,0,1-2.57,1.75H8.52a1.65,1.65,0,0,1-1.65-1.66,1.69,1.69,0,0,1,.08-.5L9.36,94.9a3,3,0,0,1,2.9-2.11H28.82l0-1.35a3.32,3.32,0,0,0-3.41-3.22H10.75c-2.7,0-6.35,1.89-7.1,4.19L.24,103c-.75,2.3.22,6,3.67,6H20c3.2,0,5.27-2.86,6-5.16Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M124.56,88.22,108,109h8.06l2.64-3.71h10.89l.93,3.71h7.83l-5.79-20.74ZM122,100.59l4.72-6.65,1.68,6.65Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M162.19,96.2H149.46A1.19,1.19,0,0,1,148.27,95a1.09,1.09,0,0,1,.06-.36l.13-.4a2.1,2.1,0,0,1,2-1.45h16.3l0-1.35a3.33,3.33,0,0,0-3.41-3.23H148.68c-1.8,0-5.46,1.16-6.21,3.82l-1.18,4c-1,3,1,4.52,2.94,4.52h13a1.3,1.3,0,0,1,1.3,1.29,1.45,1.45,0,0,1-.06.41l-.14.44a2.36,2.36,0,0,1-2.18,1.65H139.3l-.1,1.93a2.9,2.9,0,0,0,3,2.65h16.29a7.51,7.51,0,0,0,4.82-2.37c1.07-1.25,2.23-5.26,2.24-7.16A3.29,3.29,0,0,0,162.19,96.2Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M112,96.21H97.62l-1.49,4.65h8l-.6,1.78a3,3,0,0,1-2.57,1.75H92.13a1.65,1.65,0,0,1-1.65-1.66,1.69,1.69,0,0,1,.08-.5L93,94.9a3,3,0,0,1,2.9-2.11h16.56l0-1.35A3.32,3.32,0,0,0,109,88.22H94.36c-2.7,0-6.35,1.89-7.1,4.19L83.85,103c-.75,2.3.22,6,3.67,6h16c3.2,0,5.27-2.86,6-5.16Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M50.5,67.58h52.26c10.44,0,17.17-9.33,19.6-16.81L132,20.7H80.08a6.89,6.89,0,0,0-6.55,4.76L68.11,42a3.73,3.73,0,0,0,2.42,4.69,3.56,3.56,0,0,0,1.13.18H91.55c2.24,0,5.1-1.79,5.8-3.94l1.35-4h-18L84,28.38H116.5L111,45.55c-1.68,5.19-6.35,11.65-13.58,11.65H38.22C39.44,62.69,43.31,67.58,50.5,67.58Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M60.65,19.83c1.68-5.19,9.92-9.45,16-9.45h56.12C131.58,4.89,127.71,0,120.51,0H72.78C64,0,52.08,6.15,49.66,13.64L39,46.85H52Z"
    })))
  );
}

function CloseIcon() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      id: "close-icon",
      "data-name": "Close Icon",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M13.06,12l3.47-3.47a.75.75,0,0,0-1.06-1.06L12,10.94,8.53,7.47A.75.75,0,0,0,7.47,8.53L10.94,12,7.47,15.47a.75.75,0,0,0,0,1.06.75.75,0,0,0,1.06,0L12,13.06l3.47,3.47a.75.75,0,0,0,1.06,0,.75.75,0,0,0,0-1.06Z"
    }))
  );
}

var _templateObject$5, _templateObject2$1;

var StyledDealerInfo = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n\tborder-radius: ", ";\n\tborder: 1px solid\n\t\t", ";\n\tpadding: 2rem 3rem;\n\tposition: relative;\n\tmargin-bottom: 1.25rem;\n\tcursor: ", ";\n\n\t", " {\n\t\tpadding: 1.5rem 1.2rem;\n\t}\n\n\t.close-dealer {\n\t\tposition: absolute;\n\t\ttop: 2rem;\n\t\tright: 3rem;\n\t\tdisplay: none;\n\n\t\t", " {\n\t\t\ttop: 1.5rem;\n\t\t\tright: 1.2rem;\n\t\t\tdisplay: block;\n\t\t}\n\n\t\tsvg {\n\t\t\tfill: ", ";\n\t\t\twidth: 1.5rem;\n\t\t\theight: 1.5rem;\n\t\t}\n\t}\n\n\t.dealer-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\n\t\th4,\n\t\tspan {\n\t\t\tcolor: ", ";\n\t\t\tfont-size: ", ";\n\t\t\tfont-family: ", ";\n\t\t\tfont-weight: ", ";\n\t\t\tfont-style: ", ";\n\t\t\tline-height: ", ";\n\t\t\ttext-transform: ", ";\n\t\t\tletter-spacing: ", ";\n\t\t\tmargin: 1.75rem 0;\n\t\t}\n\t}\n\n\tp {\n\t\tcolor: ", ";\n\t\tfont-size: ", ";\n\t\tfont-family: ", ";\n\t\tline-height: ", ";\n\t}\n\n\tbutton {\n\t\tdisplay: flex;\n\t\tmargin-top: 3rem;\n\t\tjustify-content: center;\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.background.sidebar;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shape.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme,
      active = _ref3.active;
  return active ? theme.colors.primary : theme.background.sidebar;
}, function (_ref4) {
  var active = _ref4.active;
  return active ? 'default' : 'pointer';
}, down('md'), down('md'), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.text;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.headline;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.label.fontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.label.fontFamily;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.label.fontWeight;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.label.fontStyle;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.label.lineHeight;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.typography.label.textTransform;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.label.letterSpacing;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.text;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.body1.fontSize;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.body1.fontFamily;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.typography.body1.lineHeight;
});
var StyledDealerBrands = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\n\tspan {\n\t\twidth: 34px;\n\t\theight: 34px;\n\t\tmargin-right: 0.6rem;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tsvg {\n\t\t\twidth: 20px;\n\t\t\tfill: ", ";\n\t\t}\n\n\t\t&.ktm {\n\t\t\tbackground: #ff6600;\n\n\t\t\tsvg {\n\t\t\t\tfill: ", ";\n\t\t\t}\n\t\t}\n\t\t&.hqv {\n\t\t\tbackground: #002550;\n\t\t}\n\t\t&.gasgas {\n\t\t\tbackground: #cb0d25;\n\t\t}\n\t}\n"])), function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.white;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.black;
});

var convertToKM = function convertToKM(values) {
  var realM = values / 1000;
  var Kilometers = Math.floor(realM);
  return Kilometers;
};

var useClickOutside$1 = function useClickOutside(ref, callback) {
  var handleClick = function handleClick(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  React__default.useEffect(function () {
    document.addEventListener('click', handleClick);
    return function () {
      document.removeEventListener('click', handleClick);
    };
  });
};

var DealerInfo = function DealerInfo(_ref20) {
  var dealer = _ref20.dealer,
      onSubmit = _ref20.onSubmit,
      onSubmitLabel = _ref20.onSubmitLabel,
      onClick = _ref20.onClick,
      onCloseCard = _ref20.onCloseCard;

  var _useLocale = useLocale(),
      t = _useLocale.t;

  var _useState = useState(false),
      showButton = _useState[0],
      setShowButton = _useState[1];

  var clickRef = React__default.useRef();
  var onSubmitDealer = useCallback(function () {
    onSubmit(dealer);
  }, [dealer]);
  var onClickOutside = useCallback(function () {
    setShowButton(false);
  }, [showButton]);
  useClickOutside$1(clickRef, onClickOutside);
  return (
    /*#__PURE__*/
    React__default.createElement(StyledDealerInfo, {
      ref: clickRef,
      onClick: function onClick() {
        return setShowButton(true);
      },
      active: showButton || !onClick ? true : false
    },
    /*#__PURE__*/
    React__default.createElement(StyledDealerBrands, null, dealer && dealer.Brands ? dealer.Brands.map(function (brandName) {
      if (brandName === 'ktm' || brandName === 1) return (
        /*#__PURE__*/
        React__default.createElement("span", {
          className: "ktm"
        },
        /*#__PURE__*/
        React__default.createElement(KTMLogo, null))
      );
      if (brandName === 'husqvarna' || brandName === 2) return (
        /*#__PURE__*/
        React__default.createElement("span", {
          className: "hqv"
        },
        /*#__PURE__*/
        React__default.createElement(HQVLogo, null))
      );
      if (brandName === 'gasGas' || brandName === 5) return (
        /*#__PURE__*/
        React__default.createElement("span", {
          className: "gasgas"
        },
        /*#__PURE__*/
        React__default.createElement(GasGasLogo, null))
      );
    }) : null), onCloseCard ?
    /*#__PURE__*/
    React__default.createElement("span", {
      className: "close-dealer",
      onClick: function onClick() {
        return onCloseCard(null);
      }
    },
    /*#__PURE__*/
    React__default.createElement(CloseIcon, null)) : null,
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "dealer-header"
    },
    /*#__PURE__*/
    React__default.createElement("h4", {
      key: dealer.Id
    }, dealer.Name),
    /*#__PURE__*/
    React__default.createElement("span", null, convertToKM(dealer.Distance), "km")),
    /*#__PURE__*/
    React__default.createElement("p", null, dealer.Street, ", ", dealer.PostCode, " ", dealer.Town), !onClick || showButton ?
    /*#__PURE__*/
    React__default.createElement(Button, {
      className: "set-dealer",
      type: "submit",
      onClick: onSubmitDealer
    }, t(onSubmitLabel || 'dealer.form.select_dealer')) : null)
  );
};

var useDeviceDetect = function useDeviceDetect() {
  var _useState = useState(false),
      isMobile = _useState[0],
      setMobile = _useState[1];

  useEffect(function () {
    var userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
    var mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
    setMobile(mobile);
  }, []);
  return {
    isMobile: isMobile
  };
};

function MapIcon() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19.5 17.5"
    },
    /*#__PURE__*/
    React__default.createElement("g", {
      id: "map-icon",
      "data-name": "Map Icon"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M18.3,1.7,13.62.14a2.73,2.73,0,0,0-1.74,0L7.15,1.72a1.32,1.32,0,0,1-.39.06h0a1.32,1.32,0,0,1-.39-.06L2.3.37A1.73,1.73,0,0,0,.73.61,1.75,1.75,0,0,0,0,2V13.37a1.74,1.74,0,0,0,1,1.56l4.55,2.28a2.88,2.88,0,0,0,1.22.29h0A2.74,2.74,0,0,0,8,17.21l4.21-2.11a1.43,1.43,0,0,1,.54-.13h0a1.43,1.43,0,0,1,.54.13L17,16.93a1.72,1.72,0,0,0,1.7-.07,1.74,1.74,0,0,0,.83-1.49v-12A1.75,1.75,0,0,0,18.3,1.7ZM1.64,13.59a.24.24,0,0,1-.14-.22V2a.29.29,0,0,1,.1-.21.27.27,0,0,1,.15,0h.08L5.88,3.14l.12,0v12.6ZM7.5,15.77V3.17l.12,0L12,1.68V13.59a2.11,2.11,0,0,0-.48.17Zm10.5-.4a.23.23,0,0,1-.12.21.22.22,0,0,1-.24,0L14,13.76a2.11,2.11,0,0,0-.48-.17V1.68l4.33,1.45a.24.24,0,0,1,.17.23Z"
    })))
  );
}

function ListIcon() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19.5 19.5"
    },
    /*#__PURE__*/
    React__default.createElement("g", {
      id: "list-icon",
      "data-name": "List Icon"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M16.75,0h-14A2.75,2.75,0,0,0,0,2.75V5.5A2.75,2.75,0,0,0,2.75,8.25h14A2.75,2.75,0,0,0,19.5,5.5V2.75A2.75,2.75,0,0,0,16.75,0ZM18,5.5a1.25,1.25,0,0,1-1.25,1.25h-14A1.25,1.25,0,0,1,1.5,5.5V2.75A1.25,1.25,0,0,1,2.75,1.5h14A1.25,1.25,0,0,1,18,2.75Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M16.75,11.25h-14A2.75,2.75,0,0,0,0,14v2.75A2.75,2.75,0,0,0,2.75,19.5h14a2.75,2.75,0,0,0,2.75-2.75V14A2.75,2.75,0,0,0,16.75,11.25ZM18,16.75A1.25,1.25,0,0,1,16.75,18h-14A1.25,1.25,0,0,1,1.5,16.75V14a1.25,1.25,0,0,1,1.25-1.25h14A1.25,1.25,0,0,1,18,14Z"
    })))
  );
}

var _templateObject$6;

var StyledMobileFilter = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n\tdisplay: none;\n\n\t", " {\n\t\tdisplay: block;\n\t}\n\n\t.filter-container {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 0 0.25rem 2rem;\n\n\t\t.filter-option {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\twidth: 50%;\n\t\t\tposition: relative;\n\n\t\t\tselect {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 100%;\n\t\t\t\topacity: 0;\n\t\t\t\tfont-size: ", ";\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tcolor: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tfont-variant: all-small-caps;\n\t\t\t\tletter-spacing: 0.1em;\n\n\t\t\t\tsvg {\n\t\t\t\t\tfill: ", ";\n\t\t\t\t\twidth: 22px;\n\t\t\t\t\theight: 22px;\n\t\t\t\t\tmargin-right: 1rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.sort-option {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-end;\n\t\t\twidth: 50%;\n\t\t\tposition: relative;\n\n\t\t\t&:first-of-type {\n\t\t\t\talign-items: flex-start;\n\t\t\t}\n\n\t\t\tselect {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 100%;\n\t\t\t\topacity: 0;\n\t\t\t\tfont-size: ", ";\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tcolor: ", ";\n\t\t\t\tfont-size: ", ";\n\t\t\t\tline-height: ", ";\n\t\t\t\tfont-family: ", ";\n\t\t\t\tfont-weight: ", ";\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tfont-variant: all-small-caps;\n\t\t\t\tletter-spacing: 0.1em;\n\n\t\t\t\tsvg {\n\t\t\t\t\tfill: ", ";\n\t\t\t\t\twidth: 22px;\n\t\t\t\t\theight: 22px;\n\t\t\t\t\tmargin-left: 1rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.selected-container {\n\t\tmargin-bottom: 0.5rem;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\twidth: 100%;\n\n\t\t.selected-option {\n\t\t\tcolor: ", ";\n\t\t\tfont-size: ", ";\n\t\t\tfont-family: ", ";\n\t\t\tfont-weight: ", ";\n\t\t\tborder: 1px solid ", ";\n\t\t\tborder-radius: ", ";\n\t\t\tpadding: 0.75rem 1rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\twidth: max-content;\n\t\t\tmargin: 0 0.5rem 0.5rem 0;\n\n\t\t\tspan {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\tsvg {\n\t\t\t\t\tfill: ", ";\n\t\t\t\t\twidth: 1rem;\n\t\t\t\t\theight: 1rem;\n\t\t\t\t\tmargin-left: 0.8rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"])), down('md'), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.fontSize.xs;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.text;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.fontSize.s;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.fontSize.m;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.body1.fontFamily;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.fontWeight.bold;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.text;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.fontSize.xs;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.text;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.fontSize.s;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.fontSize.m;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.typography.body1.fontFamily;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.fontWeight.bold;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.text;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.text;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.body1.fontSize;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.typography.body1.fontFamily;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.typography.body1.fontWeight;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.text;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.shape.borderRadiusRound;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.text;
});

function RangeIcon() {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19.5 19.5"
    },
    /*#__PURE__*/
    React__default.createElement("g", {
      id: "range-icon",
      "data-name": "Range Icon"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12.85,11.21a.75.75,0,0,0-.84.64.75.75,0,0,0,.64.85C16,13.16,18,14.36,18,15.25,18,16.37,14.79,18,9.75,18S1.5,16.37,1.5,15.25c0-.89,2-2.09,5.35-2.55a.75.75,0,0,0,.64-.85.75.75,0,0,0-.84-.64c-4.1.56-6.65,2.11-6.65,4C0,18,5,19.5,9.75,19.5S19.5,18,19.5,15.25C19.5,13.32,17,11.77,12.85,11.21Z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M9,7.42v7.33a.75.75,0,0,0,1.5,0V7.42a3.7,3.7,0,0,0,1.9-1,3.75,3.75,0,1,0-5.3,0A3.7,3.7,0,0,0,9,7.42ZM8.16,2.16a2.25,2.25,0,1,1,0,3.18A2.23,2.23,0,0,1,8.16,2.16Z"
    })))
  );
}

var _templateObject$7;

var StyledDealerFilter = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n\t.filter-container {\n\t\t.filter-option {\n\t\t\tspan {\n\t\t\t\tcolor: ", ";\n\n\t\t\t\tsvg {\n\t\t\t\t\tfill: ", ";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.sort-option {\n\t\t\tspan {\n\t\t\t\tcolor: ", ";\n\n\t\t\t\tsvg {\n\t\t\t\t\tfill: ", ";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.selected-container {\n\t\t.selected-option {\n\t\t\tcolor: ", ";\n\t\t\tborder: 1px solid ", ";\n\n\t\t\t&.selected-brand {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tsvg {\n\t\t\t\t\tfill: ", ";\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.black;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.black;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.black;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.black;
});

var DealerFilter = function DealerFilter(_ref8) {
  var distance = _ref8.distance,
      distanceOptions = _ref8.distanceOptions,
      onChangeDistance = _ref8.onChangeDistance;

  var _useLocale = useLocale(),
      t = _useLocale.t;

  var _useState = useState(false),
      openFilter = _useState[0],
      showFilter = _useState[1];

  var clickRef = useRef();
  var selectedDistance = useMemo(function () {
    return distanceOptions.find(function (option) {
      return option.value + '' === distance + '';
    });
  }, [distance, distanceOptions]);
  var onSelectDistance = useCallback(function (item) {
    onChangeDistance(item.currentTarget.value);
  }, [onChangeDistance]);
  var closeFilters = useCallback(function () {
    showFilter(false);
  }, [openFilter]);
  useClickOutside(clickRef, closeFilters);
  return (
    /*#__PURE__*/
    React__default.createElement(StyledDealerFilter, null,
    /*#__PURE__*/
    React__default.createElement(StyledMobileFilter, null,
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "filter-container"
    },
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "sort-option"
    },
    /*#__PURE__*/
    React__default.createElement("span", {
      className: "sort-field"
    }, t('Range'),
    /*#__PURE__*/
    React__default.createElement(RangeIcon, null)), distanceOptions.length !== 0 &&
    /*#__PURE__*/
    React__default.createElement("select", {
      value: selectedDistance && selectedDistance.value ? selectedDistance.value : t('50'),
      onChange: function onChange(e) {
        return onSelectDistance(e);
      }
    }, distanceOptions.map(function (_ref9, index) {
      var label = _ref9.label,
          value = _ref9.value;
      return (
        /*#__PURE__*/
        React__default.createElement("option", {
          key: value,
          value: value,
          id: index,
          selected: true
        }, label)
      );
    })))),
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "selected-container"
    }, selectedDistance && selectedDistance.label ?
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "selected-option"
    }, selectedDistance.label) : null)))
  );
};

var _excluded = ["SapNumber", "Brand"];

var _templateObject$8, _templateObject2$2, _templateObject3, _templateObject4, _templateObject5;

var StyledDealerSearch = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tbackground-color: ", ";\n\theight: calc(100vh - 4rem);\n\twidth: 100%;\n\tposition: relative;\n\tmargin-top: 4rem;\n\n\t", " {\n\t\theight: 100vh;\n\t\tbackground-color: #f5f5f5;\n\t\tmargin-top: 0;\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.background.sidebar;
}, down('md'));
var StyledDealerForm = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n\tmargin-bottom: 1rem;\n\tdisplay: flex;\n\twidth: 100%;\n\n\t", " {\n\t\tflex-wrap: wrap;\n\t\tmargin-bottom: 0;\n\t}\n\n\t.dealer-distance-filter {\n\t\t", " {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t.select-dropdown {\n\t\t\twidth: 90%;\n\t\t\tmargin-left: 0.5rem;\n\t\t}\n\t}\n"])), down('md'), down('md'));
var StyledDealerContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\twidth: 33.33%;\n\tmin-width: 430px;\n\tmargin-left: 2rem;\n\tpadding-top: 2rem;\n\tposition: relative;\n\toverflow: auto;\n\theight: calc(100vh - 4rem);\n\t-ms-overflow-style: none; /* IE and Edge */\n\tscrollbar-width: none; /* Firefox */\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\t", " {\n\t\twidth: 50%;\n\t\tmargin-right: 1.5rem;\n\t}\n\n\t", " {\n\t\twidth: 100%;\n\t\theight: ", ";\n\t\tpadding: 1.5rem 1.5rem 0;\n\t\tmargin-left: 0;\n\t\tmargin-right: 0;\n\t\tmin-width: unset;\n\t}\n"])), down('lg'), down('md'), function (_ref2) {
  var active = _ref2.active;
  return active ? 'max-content' : '100%';
});
var StyledDealerNavigation = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\t.view-selection {\n\t\tdisplay: none;\n\n\t\t", " {\n\t\t\tdisplay: block;\n\t\t}\n\n\t\tspan {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: 2rem;\n\t\t\tcolor: ", ";\n\t\t\tfont-size: ", ";\n\t\t\tline-height: ", ";\n\t\t\tfont-family: ", ";\n\t\t\tfont-weight: ", ";\n\n\t\t\tsvg {\n\t\t\t\tfill: ", ";\n\t\t\t\twidth: 18px;\n\t\t\t\theight: auto;\n\t\t\t\tmargin-left: 0.5rem;\n\t\t\t}\n\t\t}\n\t}\n"])), down('md'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.body1.fontSize;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.body1.lineHeight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.body1.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.body1.fontWeight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.black;
});
var StyledDealerContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tdisplay: block;\n\n\t", " {\n\t\tdisplay: ", ";\n\t}\n"])), down('md'), function (_ref9) {
  var active = _ref9.active;
  return active ? 'block' : 'none';
});

var DealerSearch = function DealerSearch(_ref10) {
  var apiUrl = _ref10.apiUrl,
      googleMapsKey = _ref10.googleMapsKey,
      onSelect = _ref10.onSelect,
      surpressNotifications = _ref10.surpressNotifications,
      onSaveLabel = _ref10.onSaveLabel,
      onClose = _ref10.onClose,
      startBrand = _ref10.startBrand,
      qualification = _ref10.qualification,
      isXBow = _ref10.isXBow;
  window['GOOGLE_MAPS_KEY'] = googleMapsKey;

  var _useLocale = useLocale(),
      t = _useLocale.t;

  var _useNotifications = useNotifications(),
      addNotification = _useNotifications.addNotification;

  var _useDeviceDetect = useDeviceDetect(),
      isMobile = _useDeviceDetect.isMobile;

  var _useState = useState(null),
      selectedDealer = _useState[0],
      setSelectedDealer = _useState[1];

  var _useState2 = useState(false),
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      viewOption = _useState3[0],
      setViewOption = _useState3[1];

  var _useDealerSearch = useDealerSearch(apiUrl, startBrand, isXBow, qualification),
      dealers = _useDealerSearch.dealers,
      distance = _useDealerSearch.distance,
      onSetLocation = _useDealerSearch.onSetLocation,
      onSetDistance = _useDealerSearch.onSetDistance,
      onSetBrand = _useDealerSearch.onSetBrand,
      brand = _useDealerSearch.brand;

  var onSelectLocation = useCallback(function (address) {
    setSelectedDealer(null);
    onSetLocation(address);
  }, [selectedDealer, dealers]);
  var onSelectDistance = useCallback(function (event) {
    onSetDistance(!isNaN(Number(event.value)) ? Number(event.value) : event);
    setOpen(false);
  }, []);
  var onSelectDealer = useCallback(function (dealer) {
    setSelectedDealer(dealer);
  }, [setSelectedDealer]);
  var onSelectBrand = useCallback(function (brands) {
    setSelectedDealer(null);
    onSetBrand(brands);
    if (brands === brand && brand !== 'all') onSetBrand('all');
  }, [onSetBrand, setSelectedDealer]);
  var onSubmit = useCallback(function (payload) {
    try {
      return Promise.resolve(_catch(function () {
        return Promise.resolve(onSelect(payload)).then(function (saved) {
          if (!surpressNotifications) {
            addNotification({
              message: t('notifications.saved_success')
            });
          }

          return saved;
        });
      }, function (e) {
        addNotification({
          message: t("notifications." + getFormErrorCode(e)),
          type: 'error'
        });
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [onSelect]);
  var groupedDealers = dealers ? dealers.reduce(function (r, _ref11) {
    var SapNumber = _ref11.SapNumber,
        Brand = _ref11.Brand,
        object = _objectWithoutPropertiesLoose(_ref11, _excluded);

    var temp = r.find(function (o) {
      return o.SapNumber === SapNumber && o.SapNumber != '';
    });
    if (!temp) r.push(temp = _extends({
      SapNumber: SapNumber,
      Brands: []
    }, object));
    temp.Brands.push(Brand);
    return r;
  }, []) : null;
  var distanceOptions = [{
    value: '10',
    label: '10km'
  }, {
    value: '25',
    label: '25km'
  }, {
    value: '50',
    label: '50km'
  }, {
    value: '100',
    label: '100km'
  }, {
    value: '200',
    label: '200km'
  }];
  var xBowDistanceOptions = [{
    value: '50',
    label: '50km'
  }, {
    value: '100',
    label: '100km'
  }, {
    value: '200',
    label: '200km'
  }, {
    value: '500',
    label: '500km'
  }, {
    value: '1000',
    label: '1000km'
  }, {
    value: '15000',
    label: '15000km'
  }];
  return (
    /*#__PURE__*/
    React__default.createElement(StyledDealerSearch, {
      className: "dealersearch"
    },
    /*#__PURE__*/
    React__default.createElement(StyledDealerContainer, {
      active: viewOption || !isMobile,
      className: "dealersearch-container-map"
    },
    /*#__PURE__*/
    React__default.createElement(GoogleMaps, {
      markers: dealers && groupedDealers ? groupedDealers.map(function (dealer) {
        return {
          title: dealer.Name,
          position: {
            lat: dealer.Latitude,
            lng: dealer.Longitude
          },
          onClick: function onClick() {
            return onSelectDealer(dealer);
          }
        };
      }) : [],
      isXBow: isXBow
    })),
    /*#__PURE__*/
    React__default.createElement(StyledDealerContent, {
      active: viewOption,
      className: "dealersearch-container"
    },
    /*#__PURE__*/
    React__default.createElement(StyledDealerNavigation, null, onClose ?
    /*#__PURE__*/
    React__default.createElement("p", null) : null, isMobile ?
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "view-selection",
      onClick: function onClick() {
        return setViewOption(!viewOption);
      }
    }, viewOption ?
    /*#__PURE__*/
    React__default.createElement("span", {
      className: "list-selection"
    }, "List View ",
    /*#__PURE__*/
    React__default.createElement(ListIcon, null)) :
    /*#__PURE__*/
    React__default.createElement("span", {
      className: "map-selection"
    }, "Map View ",
    /*#__PURE__*/
    React__default.createElement(MapIcon, null))) : null),
    /*#__PURE__*/
    React__default.createElement(StyledDealerForm, null,
    /*#__PURE__*/
    React__default.createElement(GoogleAddressAutoComplete, {
      onSelect: onSelectLocation,
      placeholder: t('dealer.dealersearch')
    }),
    /*#__PURE__*/
    React__default.createElement("div", {
      className: "dealer-distance-filter"
    },
    /*#__PURE__*/
    React__default.createElement(DropdownSelect, {
      placeholder: t('dealer.distance'),
      value: distance ? distance + '' : null,
      options: isXBow ? xBowDistanceOptions : distanceOptions,
      onChange: onSelectDistance,
      trackingClass: 'logbook-bikes-dropdown'
    })), isMobile ?
    /*#__PURE__*/
    React__default.createElement(DealerFilter, {
      distance: distance,
      distanceOptions: isXBow ? xBowDistanceOptions : distanceOptions,
      onChangeDistance: onSelectDistance
    }) : null),
    /*#__PURE__*/
    React__default.createElement(StyledDealerContainer, {
      active: !viewOption || selectedDealer
    }, dealers && groupedDealers && !selectedDealer ? groupedDealers.map(function (dealer, key) {
      return (
        /*#__PURE__*/
        React__default.createElement(DealerInfo, {
          key: key,
          dealer: dealer,
          onSubmitLabel: onSaveLabel,
          onSubmit: onSubmit,
          onClick: true
        })
      );
    }) : null), selectedDealer ?
    /*#__PURE__*/
    React__default.createElement(DealerInfo, {
      dealer: selectedDealer,
      onSubmitLabel: onSaveLabel,
      onSubmit: onSubmit,
      onCloseCard: onSelectDealer
    }) : null))
  );
};

var FONT_SIZE_XXXS = '12px';
var FONT_SIZE_XXS = '14px';
var FONT_SIZE_XS = '16px';
var FONT_SIZE_S = '18px';
var FONT_SIZE_M = '20px';
var FONT_SIZE_L = '24px';
var FONT_SIZE_XL = '26px';
var FONT_SIZE_XXL = '36px';
var FONT_SIZE_XXXL = '72px';
var LINE_HEIGHT_XXS = '16px';
var LINE_HEIGHT_XS = '19px';
var LINE_HEIGHT_S = '20px';
var LINE_HEIGHT_M = '24px';
var LINE_HEIGHT_XL = '30px';
var LINE_HEIGHT_XXL = '42px';
var WHITE = '#ffffff';
var BLACK = '#000000';
var RED = '#DA1E28';
var GREEN = '#2bd783';
var GREY = '#232323';
var GREY_LIGHT = '#F5F5F5';
var GREY_MEDIUM = '#2E2E2E';
var GREY_DARK = '#232323';
var ORANGE = '#ff6600';
var KTM_GREY_LIGHT = '#ECECEC';
var KTM_GREY_MEDIUM = '#D0D0D0';
var KTM_GREY_DARK = '#878787';
var BLUE = '#002550';
var YELLOW = '#FFED00';
var HQV_GREY_LIGHT = '#F2F2F2';
var HQV_GREY_MEDIUM = '#D0D0D0';
var HQV_GREY_DARK = '#878787';
var GASGASRED = '#CB0D25';
var GASGAS_GREY_LIGHT = '#ECECEC';
var GASGAS_GREY_MEDIUM = '#D0D0D0';
var GASGAS_GREY_DARK = '#878787';
var FONT_FAMILY_HEADING = 'Source Sans Pro,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';
var FONT_FAMILY_CONTENT = 'Source Sans Pro,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';
var KTM_FONT_FAMILY_HEADING = 'BlenderProHeavy,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';
var KTM_FONT_FAMILY_CONTENT = 'TradeGothicLTStd,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';
var HQV_FONT_FAMILY_HEADING = 'HelveticaNeue,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';
var HQV_FONT_FAMILY_CONTENT = 'HelveticaNeue,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';
var GASGAS_FONT_FAMILY_HEADING = 'Industry,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';
var GASGAS_FONT_FAMILY_CONTENT = 'Rajdhani,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif';
var neutralTheme = {
  name: 'Neutral Theme',
  colors: {
    primary: GREY_DARK,
    secondary: GREY_DARK,
    text: GREY_DARK,
    headline: KTM_GREY_DARK,
    error: RED,
    success: GREEN,
    background: GREY_DARK,
    white: WHITE,
    black: BLACK,
    grey: GREY_DARK,
    greyLight: KTM_GREY_LIGHT,
    greyMedium: KTM_GREY_MEDIUM,
    greyDark: KTM_GREY_DARK,
    button: WHITE
  },
  background: {
    sidebar: WHITE,
    content: GREY_LIGHT,
    widget: WHITE,
    button: GREY_DARK,
    overlay: 'rgba(240, 240, 240, 0.7)'
  },
  shadow: {
    burger: '0px 3px 5px rgba(0,0,0,0.2)'
  },
  typography: {
    h1: {
      fontFamily: FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXXL,
      fontSize_mobile: FONT_SIZE_XXL,
      fontWeight: '300',
      lineHeight: FONT_SIZE_XXXL,
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    },
    h2: {
      fontFamily: FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXL,
      fontSize_mobile: FONT_SIZE_XXL,
      fontWeight: '600',
      lineHeight: LINE_HEIGHT_XXL,
      textTransform: 'none',
      letterSpacing: '0'
    },
    h3: {
      fontFamily: FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_M,
      fontSize_mobile: FONT_SIZE_M,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_M,
      textTransform: 'none',
      letterSpacing: '0'
    },
    h4: {
      fontFamily: FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_M,
      fontSize_mobile: FONT_SIZE_S,
      fontWeight: '600',
      fontVariant: 'all-small-caps',
      lineHeight: LINE_HEIGHT_S,
      textTransform: 'uppercase',
      letterSpacing: '1px'
    },
    h5: {
      fontFamily: FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'none',
      letterSpacing: '0'
    },
    h6: {
      fontFamily: FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    button: {
      fontFamily: FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_S,
      textTransform: 'none',
      letterSpacing: '0'
    },
    label: {
      fontFamily: FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXS,
      fontSize_mobile: FONT_SIZE_XXS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    },
    body1: {
      fontFamily: FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_S,
      textTransform: 'none',
      letterSpacing: '0'
    },
    body2: {
      fontFamily: FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_M,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: FONT_SIZE_M,
      textTransform: 'none',
      letterSpacing: '0'
    },
    link: {
      fontFamily: FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '600',
      lineHeight: LINE_HEIGHT_S,
      textTransform: 'none',
      letterSpacing: '0'
    },
    fontSize: {
      xxxs: FONT_SIZE_XXXS,
      xxs: FONT_SIZE_XXS,
      xs: FONT_SIZE_XS,
      s: FONT_SIZE_S,
      m: FONT_SIZE_M,
      l: FONT_SIZE_L,
      xl: FONT_SIZE_XL,
      xxl: FONT_SIZE_XXL,
      xxxl: FONT_SIZE_XXXL
    },
    fontWeight: {
      bold: '700',
      semibold: '600',
      regular: '400',
      light: '300'
    },
    fontFamily: {
      primary: FONT_FAMILY_CONTENT,
      secondary: FONT_FAMILY_CONTENT
    }
  },
  shape: {
    borderRadius: '20px',
    borderRadiusRound: '35px',
    borderRadiusButton: '35px',
    borderWidth: '1px'
  },
  breakpoints: {
    xs: '1px',
    us: '450px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    hd: '1500px',
    uhd: '1800px'
  },
  zIndex: {
    i1: 10,
    i2: 20,
    i3: 30,
    i4: 40,
    i5: 50,
    i6: 80,
    i7: 100,
    i8: 150,
    i9: 1000,
    i10: 9999
  },
  transitions: {
    easeInQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    easeOutQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  }
};
var ktmTheme = {
  name: 'KTM Theme',
  colors: {
    primary: ORANGE,
    secondary: ORANGE,
    text: WHITE,
    headline: ORANGE,
    error: RED,
    success: GREEN,
    background: GREY_DARK,
    white: WHITE,
    black: BLACK,
    grey: GREY,
    greyLight: KTM_GREY_LIGHT,
    greyMedium: KTM_GREY_MEDIUM,
    greyDark: KTM_GREY_DARK,
    button: ORANGE
  },
  background: {
    sidebar: GREY_MEDIUM,
    content: GREY_DARK,
    widget: GREY_MEDIUM,
    button: 'transparent',
    overlay: 'rgba(35, 35, 35, 0.7)'
  },
  shadow: {
    burger: '0px 3px 5px rgba(0,0,0,0.5)'
  },
  typography: {
    h1: {
      fontFamily: KTM_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXXL,
      fontSize_mobile: FONT_SIZE_XXL,
      fontWeight: '500',
      lineHeight: FONT_SIZE_XXXL,
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    },
    h2: {
      fontFamily: KTM_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXL,
      fontSize_mobile: FONT_SIZE_XXL,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_XXL,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    h3: {
      fontFamily: KTM_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XL,
      fontSize_mobile: FONT_SIZE_S,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_XL,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    h4: {
      fontFamily: KTM_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_M,
      fontSize_mobile: FONT_SIZE_S,
      fontWeight: '400',
      fontVariant: 'normal',
      lineHeight: LINE_HEIGHT_M,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    h5: {
      fontFamily: KTM_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    h6: {
      fontFamily: KTM_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    button: {
      fontFamily: KTM_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_S,
      fontSize_mobile: FONT_SIZE_S,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_S,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    label: {
      fontFamily: KTM_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXS,
      fontSize_mobile: FONT_SIZE_XXS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    },
    body1: {
      fontFamily: KTM_FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_S,
      textTransform: 'none',
      letterSpacing: '0'
    },
    body2: {
      fontFamily: KTM_FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_M,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_M,
      textTransform: 'none',
      letterSpacing: '0'
    },
    link: {
      fontFamily: KTM_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_M,
      fontSize_mobile: FONT_SIZE_S,
      fontWeight: '400',
      lineHeight: FONT_SIZE_M,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    fontSize: {
      xxxs: FONT_SIZE_XXXS,
      xxs: FONT_SIZE_XXS,
      xs: FONT_SIZE_XS,
      s: FONT_SIZE_S,
      m: FONT_SIZE_M,
      l: FONT_SIZE_L,
      xl: FONT_SIZE_XL,
      xxl: FONT_SIZE_XXL,
      xxxl: FONT_SIZE_XXXL
    },
    fontWeight: {
      bold: '700',
      semibold: '600',
      regular: '400',
      light: '300'
    },
    fontFamily: {
      primary: KTM_FONT_FAMILY_CONTENT,
      secondary: FONT_FAMILY_CONTENT
    }
  },
  shape: {
    borderRadius: '20px',
    borderRadiusRound: '35px',
    borderRadiusButton: '0px',
    borderWidth: '1px'
  },
  breakpoints: {
    xs: '1px',
    us: '450px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    hd: '1500px',
    uhd: '1800px'
  },
  zIndex: {
    i1: 10,
    i2: 20,
    i3: 30,
    i4: 40,
    i5: 50,
    i6: 80,
    i7: 100,
    i8: 150,
    i9: 1000,
    i10: 9999
  },
  transitions: {
    easeInQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    easeOutQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  }
};
var hqvTheme = {
  name: 'HQV Theme',
  colors: {
    primary: BLUE,
    secondary: YELLOW,
    text: BLUE,
    headline: BLUE,
    error: RED,
    success: GREEN,
    background: GREY_DARK,
    white: WHITE,
    black: BLACK,
    grey: GREY_DARK,
    greyLight: HQV_GREY_LIGHT,
    greyMedium: HQV_GREY_MEDIUM,
    greyDark: HQV_GREY_DARK,
    button: WHITE
  },
  background: {
    sidebar: WHITE,
    content: HQV_GREY_LIGHT,
    widget: WHITE,
    button: BLUE,
    overlay: 'rgba(242, 242, 242, 0.7)'
  },
  shadow: {
    burger: '0px 3px 5px rgba(0,0,0,0.5)'
  },
  typography: {
    h1: {
      fontFamily: HQV_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXXL,
      fontSize_mobile: FONT_SIZE_XXL,
      fontWeight: '500',
      lineHeight: FONT_SIZE_XXXL,
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    },
    h2: {
      fontFamily: HQV_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXL,
      fontSize_mobile: FONT_SIZE_XXL,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_XXL,
      textTransform: 'none',
      letterSpacing: '0'
    },
    h3: {
      fontFamily: HQV_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XL,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_XL,
      textTransform: 'none',
      letterSpacing: '0'
    },
    h4: {
      fontFamily: HQV_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_S,
      fontSize_mobile: FONT_SIZE_S,
      fontWeight: '500',
      fontVariant: 'normal',
      lineHeight: LINE_HEIGHT_M,
      textTransform: 'none',
      letterSpacing: '0'
    },
    h5: {
      fontFamily: HQV_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_S,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'none',
      letterSpacing: '0'
    },
    h6: {
      fontFamily: HQV_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'none',
      letterSpacing: '0'
    },
    button: {
      fontFamily: HQV_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_S,
      textTransform: 'none',
      letterSpacing: '0'
    },
    label: {
      fontFamily: HQV_FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXS,
      fontSize_mobile: FONT_SIZE_XXS,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    body1: {
      fontFamily: HQV_FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '300',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'none',
      letterSpacing: '0'
    },
    body2: {
      fontFamily: HQV_FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_M,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '300',
      lineHeight: FONT_SIZE_M,
      textTransform: 'none',
      letterSpacing: '0'
    },
    link: {
      fontFamily: HQV_FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '500',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'none',
      letterSpacing: '0'
    },
    fontSize: {
      xxxs: FONT_SIZE_XXXS,
      xxs: FONT_SIZE_XXS,
      xs: FONT_SIZE_XS,
      s: FONT_SIZE_S,
      m: FONT_SIZE_M,
      l: FONT_SIZE_L,
      xl: FONT_SIZE_XL,
      xxl: FONT_SIZE_XXL,
      xxxl: FONT_SIZE_XXXL
    },
    fontWeight: {
      bold: '700',
      semibold: '600',
      regular: '400',
      light: '300'
    },
    fontFamily: {
      primary: HQV_FONT_FAMILY_CONTENT,
      secondary: FONT_FAMILY_CONTENT
    }
  },
  shape: {
    borderRadius: '20px',
    borderRadiusRound: '35px',
    borderRadiusButton: '0px',
    borderWidth: '1px'
  },
  breakpoints: {
    xs: '1px',
    us: '450px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    hd: '1500px',
    uhd: '1800px'
  },
  zIndex: {
    i1: 10,
    i2: 20,
    i3: 30,
    i4: 40,
    i5: 50,
    i6: 80,
    i7: 100,
    i8: 150,
    i9: 1000,
    i10: 9999
  },
  transitions: {
    easeInQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    easeOutQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  }
};
var gasgasTheme = {
  name: 'GasGas Theme',
  colors: {
    primary: GASGASRED,
    secondary: GASGASRED,
    text: GREY_DARK,
    headline: GASGASRED,
    error: RED,
    success: GREEN,
    background: GREY_DARK,
    white: WHITE,
    black: BLACK,
    grey: GREY_DARK,
    greyLight: GASGAS_GREY_LIGHT,
    greyMedium: GASGAS_GREY_MEDIUM,
    greyDark: GASGAS_GREY_DARK,
    button: WHITE
  },
  background: {
    sidebar: WHITE,
    content: GREY_LIGHT,
    widget: WHITE,
    button: GASGASRED,
    overlay: 'rgba(249, 249, 249, 0.7)'
  },
  shadow: {
    burger: '0px 3px 5px rgba(0,0,0,0.5)'
  },
  typography: {
    h1: {
      fontFamily: GASGAS_FONT_FAMILY_HEADING,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XXXL,
      fontSize_mobile: FONT_SIZE_XXL,
      fontWeight: '500',
      lineHeight: FONT_SIZE_XXXL,
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    },
    h2: {
      fontFamily: GASGAS_FONT_FAMILY_HEADING,
      fontStyle: 'italic',
      fontSize: FONT_SIZE_XXL,
      fontSize_mobile: FONT_SIZE_XXL,
      fontWeight: '900',
      lineHeight: LINE_HEIGHT_XXL,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    h3: {
      fontFamily: GASGAS_FONT_FAMILY_HEADING,
      fontStyle: 'italic',
      fontSize: FONT_SIZE_XL,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '900',
      lineHeight: LINE_HEIGHT_XL,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    h4: {
      fontFamily: GASGAS_FONT_FAMILY_HEADING,
      fontStyle: 'italic',
      fontSize: FONT_SIZE_S,
      fontSize_mobile: FONT_SIZE_S,
      fontWeight: '700',
      fontVariant: 'normal',
      lineHeight: LINE_HEIGHT_M,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    h5: {
      fontFamily: GASGAS_FONT_FAMILY_HEADING,
      fontStyle: 'italic',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '700',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    h6: {
      fontFamily: GASGAS_FONT_FAMILY_HEADING,
      fontStyle: 'italic',
      fontSize: FONT_SIZE_XXS,
      fontSize_mobile: FONT_SIZE_XXS,
      fontWeight: '700',
      lineHeight: LINE_HEIGHT_XXS,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    button: {
      fontFamily: GASGAS_FONT_FAMILY_HEADING,
      fontStyle: 'italic',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '700',
      lineHeight: LINE_HEIGHT_S,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    label: {
      fontFamily: GASGAS_FONT_FAMILY_HEADING,
      fontStyle: 'italic',
      fontSize: FONT_SIZE_XXS,
      fontSize_mobile: FONT_SIZE_XXS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    body1: {
      fontFamily: GASGAS_FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'none',
      letterSpacing: '0'
    },
    body2: {
      fontFamily: GASGAS_FONT_FAMILY_CONTENT,
      fontStyle: 'normal',
      fontSize: FONT_SIZE_M,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '400',
      lineHeight: FONT_SIZE_M,
      textTransform: 'none',
      letterSpacing: '0'
    },
    link: {
      fontFamily: GASGAS_FONT_FAMILY_HEADING,
      fontStyle: 'italic',
      fontSize: FONT_SIZE_XS,
      fontSize_mobile: FONT_SIZE_XS,
      fontWeight: '700',
      lineHeight: LINE_HEIGHT_XS,
      textTransform: 'uppercase',
      letterSpacing: '0'
    },
    fontSize: {
      xxxs: FONT_SIZE_XXXS,
      xxs: FONT_SIZE_XXS,
      xs: FONT_SIZE_XS,
      s: FONT_SIZE_S,
      m: FONT_SIZE_M,
      l: FONT_SIZE_L,
      xl: FONT_SIZE_XL,
      xxl: FONT_SIZE_XXL,
      xxxl: FONT_SIZE_XXXL
    },
    fontWeight: {
      bold: '700',
      semibold: '600',
      regular: '400',
      light: '300'
    },
    fontFamily: {
      primary: GASGAS_FONT_FAMILY_CONTENT,
      secondary: FONT_FAMILY_CONTENT
    }
  },
  shape: {
    borderRadius: '20px',
    borderRadiusRound: '35px',
    borderRadiusButton: '0px',
    borderWidth: '1px'
  },
  breakpoints: {
    xs: '1px',
    us: '450px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    hd: '1500px',
    uhd: '1800px'
  },
  zIndex: {
    i1: 10,
    i2: 20,
    i3: 30,
    i4: 40,
    i5: 50,
    i6: 80,
    i7: 100,
    i8: 150,
    i9: 1000,
    i10: 9999
  },
  transitions: {
    easeInQuad: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    easeOutQuad: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
  }
};
var AuthContext = createContext({
  onLogin: null,
  isLoginLoding: false,
  isUserLoading: false,
  token: null,
  isReady: false,
  isCdcReady: false,
  showContainer: false,
  isLoggedIn: false,
  onClose: null,
  onLogout: null,
  onRegister: null,
  onUpdateUser: null,
  onSaveUser: null,
  onSaveTheme: null,
  onSaveLanguage: null,
  onSaveUserImage: null,
  onSavePreferedDealer: null,
  user: null,
  site: null,
  featureFlags: null,
  userRole: null,
  error: null,
  onCleanupUser: null,
  onDisableUser: null
});

function useAuthContext() {
  var context = useContext(AuthContext);
  if (!context) throw new Error('auth context must be used inside a auth context provider.');
  return context;
}

var ThemedContext = createContext({
  themed: 'neutral',
  onChangeTheme: null
});

var ThemedContextProvider = function ThemedContextProvider(_ref) {
  var children = _ref.children,
      defaultTheme = _ref.defaultTheme;

  var _useAuthContext = useAuthContext(),
      user = _useAuthContext.user;

  var _useState = useState(defaultTheme || 'neutral'),
      themed = _useState[0],
      setThemed = _useState[1];

  var onChangeTheme = useCallback(function (theme) {
    localStorage.theme = theme;
    setThemed(theme);
  }, [themed, setThemed]);
  var theme = useMemo(function () {
    var currentTheme;

    if (themed === 'ktm') {
      currentTheme = ktmTheme;
    } else if (themed === 'gasGas') {
      currentTheme = gasgasTheme;
    } else if (themed === 'husqvarna' || themed === 'hqv') {
      currentTheme = hqvTheme;
    } else {
      currentTheme = neutralTheme;
    }

    return currentTheme;
  }, [themed]);
  useEffect(function () {
    var localTheme = window.localStorage.getItem('theme');
    if (localTheme) onChangeTheme(localTheme);

    if (user && user.colourTheme) {
      onChangeTheme(user.colourTheme);
    }
  }, [user]);
  return (
    /*#__PURE__*/
    React__default.createElement(ThemedContext.Provider, {
      value: {
        themed: themed,
        onChangeTheme: onChangeTheme
      }
    },
    /*#__PURE__*/
    React__default.createElement(ThemeProvider, {
      theme: theme
    }, children))
  );
};

var onCloseDealer = function onCloseDealer() {};

var DealerSearchComponent = function DealerSearchComponent(_ref) {
  var text = _ref.text,
      apiUrl = _ref.apiUrl,
      brand = _ref.brand,
      country = _ref.country,
      lang = _ref.lang,
      googleMapsKey = _ref.googleMapsKey,
      showBrandSelector = _ref.showBrandSelector,
      qualification = _ref.qualification,
      onSelectDealer = _ref.onSelectDealer,
      isXBow = _ref.isXBow;
  console.log('Create DealerSearchComponent with ', text, apiUrl, brand, country, lang, googleMapsKey, showBrandSelector);
  return (
    /*#__PURE__*/
    createElement("div", {
      className: styles.dealersearch
    }, text,
    /*#__PURE__*/
    createElement(LocaleContextProvider, {
      country: country,
      lang: lang
    },
    /*#__PURE__*/
    createElement(ThemedContextProvider, {
      defaultTheme: brand.toLowerCase()
    },
    /*#__PURE__*/
    createElement(NoticiationContextProvider, null,
    /*#__PURE__*/
    createElement(DealerSearch, {
      apiUrl: apiUrl,
      startBrand: brand,
      qualification: qualification,
      googleMapsKey: googleMapsKey,
      showBrandSelector: showBrandSelector,
      onSelect: onSelectDealer,
      onClose: onCloseDealer,
      isXBow: isXBow
    })))))
  );
};

export { DealerSearchComponent };